var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _rect2, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopupQrCodeIconKlead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 8.04419H11.2429V10.2787H9.0166V8.04419Z",
    fill: "url(#paint0_linear_816_5390)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 8.04419H13.4692V10.2787H11.2429V8.04419Z",
    fill: "url(#paint1_linear_816_5390)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 8.04419H15.6955V10.2787H13.4692V8.04419Z",
    fill: "url(#paint2_linear_816_5390)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 8.04419H17.9218V10.2787H15.6955V8.04419Z",
    fill: "url(#paint3_linear_816_5390)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 8.04419H20.1481V10.2787H17.9218V8.04419Z",
    fill: "url(#paint4_linear_816_5390)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 8.04419H22.3744V10.2787H20.1481V8.04419Z",
    fill: "url(#paint5_linear_816_5390)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 8.04419H24.6007V10.2787H22.3744V8.04419Z",
    fill: "url(#paint6_linear_816_5390)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 8.04419H29.0534V10.2787H26.8271V8.04419Z",
    fill: "url(#paint7_linear_816_5390)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 8.04419H31.2797V10.2787H29.0534V8.04419Z",
    fill: "url(#paint8_linear_816_5390)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 8.04419H42.4112V10.2787H40.1849V8.04419Z",
    fill: "url(#paint9_linear_816_5390)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 8.04419H44.6375V10.2787H42.4112V8.04419Z",
    fill: "url(#paint10_linear_816_5390)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 8.04419H46.8638V10.2787H44.6375V8.04419Z",
    fill: "url(#paint11_linear_816_5390)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 8.04419H49.0901V10.2787H46.8638V8.04419Z",
    fill: "url(#paint12_linear_816_5390)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 8.04419H62.448V10.2787H60.2217V8.04419Z",
    fill: "url(#paint13_linear_816_5390)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 8.04419H73.5795V10.2787H71.3532V8.04419Z",
    fill: "url(#paint14_linear_816_5390)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 8.04419H75.8058V10.2787H73.5795V8.04419Z",
    fill: "url(#paint15_linear_816_5390)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 8.04419H78.0321V10.2787H75.8058V8.04419Z",
    fill: "url(#paint16_linear_816_5390)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 8.04419H80.2584V10.2787H78.0321V8.04419Z",
    fill: "url(#paint17_linear_816_5390)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 8.04419H82.4847V10.2787H80.2584V8.04419Z",
    fill: "url(#paint18_linear_816_5390)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 8.04419H86.9373V10.2787H84.711V8.04419Z",
    fill: "url(#paint19_linear_816_5390)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 8.04419H89.1636V10.2787H86.9373V8.04419Z",
    fill: "url(#paint20_linear_816_5390)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 8.04419H91.39V10.2787H89.1636V8.04419Z",
    fill: "url(#paint21_linear_816_5390)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 8.04419H93.6163V10.2787H91.39V8.04419Z",
    fill: "url(#paint22_linear_816_5390)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 8.04419H95.8426V10.2787H93.6163V8.04419Z",
    fill: "url(#paint23_linear_816_5390)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 8.04419H98.0689V10.2787H95.8426V8.04419Z",
    fill: "url(#paint24_linear_816_5390)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 8.04419H100.295V10.2787H98.0689V8.04419Z",
    fill: "url(#paint25_linear_816_5390)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 10.2787H11.2429V12.5132H9.0166V10.2787Z",
    fill: "url(#paint26_linear_816_5390)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 10.2787H24.6007V12.5132H22.3744V10.2787Z",
    fill: "url(#paint27_linear_816_5390)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 10.2787H29.0534V12.5132H26.8271V10.2787Z",
    fill: "url(#paint28_linear_816_5390)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 10.2787H31.2797V12.5132H29.0534V10.2787Z",
    fill: "url(#paint29_linear_816_5390)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 10.2787H33.506V12.5132H31.2797V10.2787Z",
    fill: "url(#paint30_linear_816_5390)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 10.2787H35.7323V12.5132H33.506V10.2787Z",
    fill: "url(#paint31_linear_816_5390)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 10.2787H37.9586V12.5132H35.7323V10.2787Z",
    fill: "url(#paint32_linear_816_5390)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 10.2787H42.4112V12.5132H40.1849V10.2787Z",
    fill: "url(#paint33_linear_816_5390)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 10.2787H44.6375V12.5132H42.4112V10.2787Z",
    fill: "url(#paint34_linear_816_5390)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 10.2787H49.0901V12.5132H46.8638V10.2787Z",
    fill: "url(#paint35_linear_816_5390)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 10.2787H51.3164V12.5132H49.0901V10.2787Z",
    fill: "url(#paint36_linear_816_5390)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 10.2787H60.2217V12.5132H57.9954V10.2787Z",
    fill: "url(#paint37_linear_816_5390)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 10.2787H62.448V12.5132H60.2217V10.2787Z",
    fill: "url(#paint38_linear_816_5390)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 10.2787H64.6743V12.5132H62.448V10.2787Z",
    fill: "url(#paint39_linear_816_5390)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 10.2787H71.3532V12.5132H69.1269V10.2787Z",
    fill: "url(#paint40_linear_816_5390)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 10.2787H73.5795V12.5132H71.3532V10.2787Z",
    fill: "url(#paint41_linear_816_5390)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 10.2787H75.8058V12.5132H73.5795V10.2787Z",
    fill: "url(#paint42_linear_816_5390)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 10.2787H82.4847V12.5132H80.2584V10.2787Z",
    fill: "url(#paint43_linear_816_5390)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 10.2787H86.9373V12.5132H84.711V10.2787Z",
    fill: "url(#paint44_linear_816_5390)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 10.2787H100.295V12.5132H98.0689V10.2787Z",
    fill: "url(#paint45_linear_816_5390)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 12.5132H11.2429V14.7478H9.0166V12.5132Z",
    fill: "url(#paint46_linear_816_5390)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 12.5132H15.6955V14.7478H13.4692V12.5132Z",
    fill: "url(#paint47_linear_816_5390)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 12.5132H17.9218V14.7478H15.6955V12.5132Z",
    fill: "url(#paint48_linear_816_5390)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 12.5132H20.1481V14.7478H17.9218V12.5132Z",
    fill: "url(#paint49_linear_816_5390)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 12.5132H24.6007V14.7478H22.3744V12.5132Z",
    fill: "url(#paint50_linear_816_5390)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 12.5132H29.0534V14.7478H26.8271V12.5132Z",
    fill: "url(#paint51_linear_816_5390)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 12.5132H35.7323V14.7478H33.506V12.5132Z",
    fill: "url(#paint52_linear_816_5390)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 12.5132H42.4112V14.7478H40.1849V12.5132Z",
    fill: "url(#paint53_linear_816_5390)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 12.5132H44.6375V14.7478H42.4112V12.5132Z",
    fill: "url(#paint54_linear_816_5390)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 12.5132H51.3164V14.7478H49.0901V12.5132Z",
    fill: "url(#paint55_linear_816_5390)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 12.5132H53.5427V14.7478H51.3164V12.5132Z",
    fill: "url(#paint56_linear_816_5390)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 12.5132H55.769V14.7478H53.5427V12.5132Z",
    fill: "url(#paint57_linear_816_5390)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 12.5132H60.2217V14.7478H57.9954V12.5132Z",
    fill: "url(#paint58_linear_816_5390)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 12.5132H62.448V14.7478H60.2217V12.5132Z",
    fill: "url(#paint59_linear_816_5390)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 12.5132H64.6743V14.7478H62.448V12.5132Z",
    fill: "url(#paint60_linear_816_5390)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 12.5132H69.1269V14.7478H66.9006V12.5132Z",
    fill: "url(#paint61_linear_816_5390)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 12.5132H71.3532V14.7478H69.1269V12.5132Z",
    fill: "url(#paint62_linear_816_5390)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 12.5132H75.8058V14.7478H73.5795V12.5132Z",
    fill: "url(#paint63_linear_816_5390)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 12.5132H78.0321V14.7478H75.8058V12.5132Z",
    fill: "url(#paint64_linear_816_5390)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 12.5132H80.2584V14.7478H78.0321V12.5132Z",
    fill: "url(#paint65_linear_816_5390)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 12.5132H82.4847V14.7478H80.2584V12.5132Z",
    fill: "url(#paint66_linear_816_5390)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 12.5132H86.9373V14.7478H84.711V12.5132Z",
    fill: "url(#paint67_linear_816_5390)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 12.5132H91.39V14.7478H89.1636V12.5132Z",
    fill: "url(#paint68_linear_816_5390)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 12.5132H93.6163V14.7478H91.39V12.5132Z",
    fill: "url(#paint69_linear_816_5390)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 12.5132H95.8426V14.7478H93.6163V12.5132Z",
    fill: "url(#paint70_linear_816_5390)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 12.5132H100.295V14.7478H98.0689V12.5132Z",
    fill: "url(#paint71_linear_816_5390)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 14.7478H11.2429V16.9823H9.0166V14.7478Z",
    fill: "url(#paint72_linear_816_5390)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 14.7478H15.6955V16.9823H13.4692V14.7478Z",
    fill: "url(#paint73_linear_816_5390)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 14.7478H17.9218V16.9823H15.6955V14.7478Z",
    fill: "url(#paint74_linear_816_5390)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 14.7478H20.1481V16.9823H17.9218V14.7478Z",
    fill: "url(#paint75_linear_816_5390)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 14.7478H24.6007V16.9823H22.3744V14.7478Z",
    fill: "url(#paint76_linear_816_5390)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 14.7478H31.2797V16.9823H29.0534V14.7478Z",
    fill: "url(#paint77_linear_816_5390)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 14.7478H33.506V16.9823H31.2797V14.7478Z",
    fill: "url(#paint78_linear_816_5390)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 14.7478H40.1849V16.9823H37.9586V14.7478Z",
    fill: "url(#paint79_linear_816_5390)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 14.7478H42.4112V16.9823H40.1849V14.7478Z",
    fill: "url(#paint80_linear_816_5390)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 14.7478H49.0901V16.9823H46.8638V14.7478Z",
    fill: "url(#paint81_linear_816_5390)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 14.7478H53.5427V16.9823H51.3164V14.7478Z",
    fill: "url(#paint82_linear_816_5390)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 14.7478H55.769V16.9823H53.5427V14.7478Z",
    fill: "url(#paint83_linear_816_5390)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 14.7478H62.448V16.9823H60.2217V14.7478Z",
    fill: "url(#paint84_linear_816_5390)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 14.7478H71.3532V16.9823H69.1269V14.7478Z",
    fill: "url(#paint85_linear_816_5390)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 14.7478H80.2584V16.9823H78.0321V14.7478Z",
    fill: "url(#paint86_linear_816_5390)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 14.7478H82.4847V16.9823H80.2584V14.7478Z",
    fill: "url(#paint87_linear_816_5390)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 14.7478H86.9373V16.9823H84.711V14.7478Z",
    fill: "url(#paint88_linear_816_5390)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 14.7478H91.39V16.9823H89.1636V14.7478Z",
    fill: "url(#paint89_linear_816_5390)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 14.7478H93.6163V16.9823H91.39V14.7478Z",
    fill: "url(#paint90_linear_816_5390)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 14.7478H95.8426V16.9823H93.6163V14.7478Z",
    fill: "url(#paint91_linear_816_5390)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 14.7478H100.295V16.9823H98.0689V14.7478Z",
    fill: "url(#paint92_linear_816_5390)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 16.9823H11.2429V19.2168H9.0166V16.9823Z",
    fill: "url(#paint93_linear_816_5390)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 16.9823H15.6955V19.2168H13.4692V16.9823Z",
    fill: "url(#paint94_linear_816_5390)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 16.9823H17.9218V19.2168H15.6955V16.9823Z",
    fill: "url(#paint95_linear_816_5390)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 16.9823H20.1481V19.2168H17.9218V16.9823Z",
    fill: "url(#paint96_linear_816_5390)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 16.9823H24.6007V19.2168H22.3744V16.9823Z",
    fill: "url(#paint97_linear_816_5390)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 16.9823H31.2797V19.2168H29.0534V16.9823Z",
    fill: "url(#paint98_linear_816_5390)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 16.9823H35.7323V19.2168H33.506V16.9823Z",
    fill: "url(#paint99_linear_816_5390)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 16.9823H44.6375V19.2168H42.4112V16.9823Z",
    fill: "url(#paint100_linear_816_5390)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 16.9823H49.0901V19.2168H46.8638V16.9823Z",
    fill: "url(#paint101_linear_816_5390)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 16.9823H51.3164V19.2168H49.0901V16.9823Z",
    fill: "url(#paint102_linear_816_5390)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 16.9823H53.5427V19.2168H51.3164V16.9823Z",
    fill: "url(#paint103_linear_816_5390)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 16.9823H57.9954V19.2168H55.769V16.9823Z",
    fill: "url(#paint104_linear_816_5390)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 16.9823H62.448V19.2168H60.2217V16.9823Z",
    fill: "url(#paint105_linear_816_5390)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 16.9823H69.1269V19.2168H66.9006V16.9823Z",
    fill: "url(#paint106_linear_816_5390)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 16.9823H73.5795V19.2168H71.3532V16.9823Z",
    fill: "url(#paint107_linear_816_5390)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 16.9823H75.8058V19.2168H73.5795V16.9823Z",
    fill: "url(#paint108_linear_816_5390)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 16.9823H78.0321V19.2168H75.8058V16.9823Z",
    fill: "url(#paint109_linear_816_5390)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 16.9823H80.2584V19.2168H78.0321V16.9823Z",
    fill: "url(#paint110_linear_816_5390)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 16.9823H82.4847V19.2168H80.2584V16.9823Z",
    fill: "url(#paint111_linear_816_5390)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 16.9823H86.9373V19.2168H84.711V16.9823Z",
    fill: "url(#paint112_linear_816_5390)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 16.9823H91.39V19.2168H89.1636V16.9823Z",
    fill: "url(#paint113_linear_816_5390)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 16.9823H93.6163V19.2168H91.39V16.9823Z",
    fill: "url(#paint114_linear_816_5390)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 16.9823H95.8426V19.2168H93.6163V16.9823Z",
    fill: "url(#paint115_linear_816_5390)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 16.9823H100.295V19.2168H98.0689V16.9823Z",
    fill: "url(#paint116_linear_816_5390)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 19.2168H11.2429V21.4513H9.0166V19.2168Z",
    fill: "url(#paint117_linear_816_5390)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 19.2168H24.6007V21.4513H22.3744V19.2168Z",
    fill: "url(#paint118_linear_816_5390)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 19.2168H29.0534V21.4513H26.8271V19.2168Z",
    fill: "url(#paint119_linear_816_5390)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 19.2168H31.2797V21.4513H29.0534V19.2168Z",
    fill: "url(#paint120_linear_816_5390)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 19.2168H33.506V21.4513H31.2797V19.2168Z",
    fill: "url(#paint121_linear_816_5390)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 19.2168H35.7323V21.4513H33.506V19.2168Z",
    fill: "url(#paint122_linear_816_5390)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 19.2168H44.6375V21.4513H42.4112V19.2168Z",
    fill: "url(#paint123_linear_816_5390)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 19.2168H46.8638V21.4513H44.6375V19.2168Z",
    fill: "url(#paint124_linear_816_5390)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 19.2168H49.0901V21.4513H46.8638V19.2168Z",
    fill: "url(#paint125_linear_816_5390)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 19.2168H55.769V21.4513H53.5427V19.2168Z",
    fill: "url(#paint126_linear_816_5390)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 19.2168H62.448V21.4513H60.2217V19.2168Z",
    fill: "url(#paint127_linear_816_5390)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 19.2168H66.9006V21.4513H64.6743V19.2168Z",
    fill: "url(#paint128_linear_816_5390)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 19.2168H71.3532V21.4513H69.1269V19.2168Z",
    fill: "url(#paint129_linear_816_5390)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 19.2168H73.5795V21.4513H71.3532V19.2168Z",
    fill: "url(#paint130_linear_816_5390)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 19.2168H75.8058V21.4513H73.5795V19.2168Z",
    fill: "url(#paint131_linear_816_5390)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 19.2168H86.9373V21.4513H84.711V19.2168Z",
    fill: "url(#paint132_linear_816_5390)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 19.2168H100.295V21.4513H98.0689V19.2168Z",
    fill: "url(#paint133_linear_816_5390)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 21.4513H11.2429V23.6858H9.0166V21.4513Z",
    fill: "url(#paint134_linear_816_5390)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 21.4513H13.4692V23.6858H11.2429V21.4513Z",
    fill: "url(#paint135_linear_816_5390)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 21.4513H15.6955V23.6858H13.4692V21.4513Z",
    fill: "url(#paint136_linear_816_5390)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 21.4513H17.9218V23.6858H15.6955V21.4513Z",
    fill: "url(#paint137_linear_816_5390)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 21.4513H20.1481V23.6858H17.9218V21.4513Z",
    fill: "url(#paint138_linear_816_5390)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 21.4513H22.3744V23.6858H20.1481V21.4513Z",
    fill: "url(#paint139_linear_816_5390)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 21.4513H24.6007V23.6858H22.3744V21.4513Z",
    fill: "url(#paint140_linear_816_5390)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 21.4513H29.0534V23.6858H26.8271V21.4513Z",
    fill: "url(#paint141_linear_816_5390)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 21.4513H33.506V23.6858H31.2797V21.4513Z",
    fill: "url(#paint142_linear_816_5390)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 21.4513H37.9586V23.6858H35.7323V21.4513Z",
    fill: "url(#paint143_linear_816_5390)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 21.4513H42.4112V23.6858H40.1849V21.4513Z",
    fill: "url(#paint144_linear_816_5390)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 21.4513H46.8638V23.6858H44.6375V21.4513Z",
    fill: "url(#paint145_linear_816_5390)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 21.4513H51.3164V23.6858H49.0901V21.4513Z",
    fill: "url(#paint146_linear_816_5390)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 21.4513H55.769V23.6858H53.5427V21.4513Z",
    fill: "url(#paint147_linear_816_5390)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 21.4513H60.2217V23.6858H57.9954V21.4513Z",
    fill: "url(#paint148_linear_816_5390)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 21.4513H64.6743V23.6858H62.448V21.4513Z",
    fill: "url(#paint149_linear_816_5390)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 21.4513H69.1269V23.6858H66.9006V21.4513Z",
    fill: "url(#paint150_linear_816_5390)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 21.4513H73.5795V23.6858H71.3532V21.4513Z",
    fill: "url(#paint151_linear_816_5390)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 21.4513H78.0321V23.6858H75.8058V21.4513Z",
    fill: "url(#paint152_linear_816_5390)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 21.4513H82.4847V23.6858H80.2584V21.4513Z",
    fill: "url(#paint153_linear_816_5390)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 21.4513H86.9373V23.6858H84.711V21.4513Z",
    fill: "url(#paint154_linear_816_5390)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 21.4513H89.1636V23.6858H86.9373V21.4513Z",
    fill: "url(#paint155_linear_816_5390)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 21.4513H91.39V23.6858H89.1636V21.4513Z",
    fill: "url(#paint156_linear_816_5390)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 21.4513H93.6163V23.6858H91.39V21.4513Z",
    fill: "url(#paint157_linear_816_5390)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 21.4513H95.8426V23.6858H93.6163V21.4513Z",
    fill: "url(#paint158_linear_816_5390)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 21.4513H98.0689V23.6858H95.8426V21.4513Z",
    fill: "url(#paint159_linear_816_5390)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 21.4513H100.295V23.6858H98.0689V21.4513Z",
    fill: "url(#paint160_linear_816_5390)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 23.6858H29.0534V25.9204H26.8271V23.6858Z",
    fill: "url(#paint161_linear_816_5390)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 23.6858H37.9586V25.9204H35.7323V23.6858Z",
    fill: "url(#paint162_linear_816_5390)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 23.6858H42.4112V25.9204H40.1849V23.6858Z",
    fill: "url(#paint163_linear_816_5390)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 23.6858H44.6375V25.9204H42.4112V23.6858Z",
    fill: "url(#paint164_linear_816_5390)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 23.6858H46.8638V25.9204H44.6375V23.6858Z",
    fill: "url(#paint165_linear_816_5390)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 23.6858H55.769V25.9204H53.5427V23.6858Z",
    fill: "url(#paint166_linear_816_5390)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 23.6858H57.9954V25.9204H55.769V23.6858Z",
    fill: "url(#paint167_linear_816_5390)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 23.6858H64.6743V25.9204H62.448V23.6858Z",
    fill: "url(#paint168_linear_816_5390)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 23.6858H66.9006V25.9204H64.6743V23.6858Z",
    fill: "url(#paint169_linear_816_5390)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 23.6858H71.3532V25.9204H69.1269V23.6858Z",
    fill: "url(#paint170_linear_816_5390)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 23.6858H73.5795V25.9204H71.3532V23.6858Z",
    fill: "url(#paint171_linear_816_5390)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 23.6858H80.2584V25.9204H78.0321V23.6858Z",
    fill: "url(#paint172_linear_816_5390)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 23.6858H82.4847V25.9204H80.2584V23.6858Z",
    fill: "url(#paint173_linear_816_5390)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 25.9204H15.6955V28.1549H13.4692V25.9204Z",
    fill: "url(#paint174_linear_816_5390)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 25.9204H17.9218V28.1549H15.6955V25.9204Z",
    fill: "url(#paint175_linear_816_5390)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 25.9204H20.1481V28.1549H17.9218V25.9204Z",
    fill: "url(#paint176_linear_816_5390)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 25.9204H24.6007V28.1549H22.3744V25.9204Z",
    fill: "url(#paint177_linear_816_5390)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 25.9204H29.0534V28.1549H26.8271V25.9204Z",
    fill: "url(#paint178_linear_816_5390)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 25.9204H33.506V28.1549H31.2797V25.9204Z",
    fill: "url(#paint179_linear_816_5390)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 25.9204H42.4112V28.1549H40.1849V25.9204Z",
    fill: "url(#paint180_linear_816_5390)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 25.9204H66.9006V28.1549H64.6743V25.9204Z",
    fill: "url(#paint181_linear_816_5390)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 25.9204H69.1269V28.1549H66.9006V25.9204Z",
    fill: "url(#paint182_linear_816_5390)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 25.9204H75.8058V28.1549H73.5795V25.9204Z",
    fill: "url(#paint183_linear_816_5390)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 25.9204H80.2584V28.1549H78.0321V25.9204Z",
    fill: "url(#paint184_linear_816_5390)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 25.9204H84.711V28.1549H82.4847V25.9204Z",
    fill: "url(#paint185_linear_816_5390)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 25.9204H86.9373V28.1549H84.711V25.9204Z",
    fill: "url(#paint186_linear_816_5390)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 25.9204H89.1636V28.1549H86.9373V25.9204Z",
    fill: "url(#paint187_linear_816_5390)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 25.9204H95.8426V28.1549H93.6163V25.9204Z",
    fill: "url(#paint188_linear_816_5390)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 25.9204H98.0689V28.1549H95.8426V25.9204Z",
    fill: "url(#paint189_linear_816_5390)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 25.9204H100.295V28.1549H98.0689V25.9204Z",
    fill: "url(#paint190_linear_816_5390)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 28.1549H13.4692V30.3894H11.2429V28.1549Z",
    fill: "url(#paint191_linear_816_5390)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 28.1549H17.9218V30.3894H15.6955V28.1549Z",
    fill: "url(#paint192_linear_816_5390)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 28.1549H22.3744V30.3894H20.1481V28.1549Z",
    fill: "url(#paint193_linear_816_5390)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 28.1549H26.8271V30.3894H24.6007V28.1549Z",
    fill: "url(#paint194_linear_816_5390)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 28.1549H29.0534V30.3894H26.8271V28.1549Z",
    fill: "url(#paint195_linear_816_5390)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 28.1549H35.7323V30.3894H33.506V28.1549Z",
    fill: "url(#paint196_linear_816_5390)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 28.1549H44.6375V30.3894H42.4112V28.1549Z",
    fill: "url(#paint197_linear_816_5390)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 28.1549H51.3164V30.3894H49.0901V28.1549Z",
    fill: "url(#paint198_linear_816_5390)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 28.1549H57.9954V30.3894H55.769V28.1549Z",
    fill: "url(#paint199_linear_816_5390)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 28.1549H60.2217V30.3894H57.9954V28.1549Z",
    fill: "url(#paint200_linear_816_5390)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 28.1549H62.448V30.3894H60.2217V28.1549Z",
    fill: "url(#paint201_linear_816_5390)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 28.1549H64.6743V30.3894H62.448V28.1549Z",
    fill: "url(#paint202_linear_816_5390)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 28.1549H73.5795V30.3894H71.3532V28.1549Z",
    fill: "url(#paint203_linear_816_5390)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 28.1549H78.0321V30.3894H75.8058V28.1549Z",
    fill: "url(#paint204_linear_816_5390)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 28.1549H80.2584V30.3894H78.0321V28.1549Z",
    fill: "url(#paint205_linear_816_5390)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 28.1549H82.4847V30.3894H80.2584V28.1549Z",
    fill: "url(#paint206_linear_816_5390)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 28.1549H86.9373V30.3894H84.711V28.1549Z",
    fill: "url(#paint207_linear_816_5390)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 28.1549H89.1636V30.3894H86.9373V28.1549Z",
    fill: "url(#paint208_linear_816_5390)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 28.1549H91.39V30.3894H89.1636V28.1549Z",
    fill: "url(#paint209_linear_816_5390)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 28.1549H95.8426V30.3894H93.6163V28.1549Z",
    fill: "url(#paint210_linear_816_5390)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 28.1549H98.0689V30.3894H95.8426V28.1549Z",
    fill: "url(#paint211_linear_816_5390)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 28.1549H100.295V30.3894H98.0689V28.1549Z",
    fill: "url(#paint212_linear_816_5390)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 30.3894H15.6955V32.6239H13.4692V30.3894Z",
    fill: "url(#paint213_linear_816_5390)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 30.3894H20.1481V32.6239H17.9218V30.3894Z",
    fill: "url(#paint214_linear_816_5390)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 30.3894H22.3744V32.6239H20.1481V30.3894Z",
    fill: "url(#paint215_linear_816_5390)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 30.3894H24.6007V32.6239H22.3744V30.3894Z",
    fill: "url(#paint216_linear_816_5390)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 30.3894H31.2797V32.6239H29.0534V30.3894Z",
    fill: "url(#paint217_linear_816_5390)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 30.3894H33.506V32.6239H31.2797V30.3894Z",
    fill: "url(#paint218_linear_816_5390)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 30.3894H35.7323V32.6239H33.506V30.3894Z",
    fill: "url(#paint219_linear_816_5390)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 30.3894H37.9586V32.6239H35.7323V30.3894Z",
    fill: "url(#paint220_linear_816_5390)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 30.3894H51.3164V32.6239H49.0901V30.3894Z",
    fill: "url(#paint221_linear_816_5390)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 30.3894H55.769V32.6239H53.5427V30.3894Z",
    fill: "url(#paint222_linear_816_5390)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 30.3894H57.9954V32.6239H55.769V30.3894Z",
    fill: "url(#paint223_linear_816_5390)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 30.3894H71.3532V32.6239H69.1269V30.3894Z",
    fill: "url(#paint224_linear_816_5390)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 30.3894H82.4847V32.6239H80.2584V30.3894Z",
    fill: "url(#paint225_linear_816_5390)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 30.3894H86.9373V32.6239H84.711V30.3894Z",
    fill: "url(#paint226_linear_816_5390)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 30.3894H89.1636V32.6239H86.9373V30.3894Z",
    fill: "url(#paint227_linear_816_5390)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 30.3894H91.39V32.6239H89.1636V30.3894Z",
    fill: "url(#paint228_linear_816_5390)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 30.3894H98.0689V32.6239H95.8426V30.3894Z",
    fill: "url(#paint229_linear_816_5390)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 32.6239H13.4692V34.8585H11.2429V32.6239Z",
    fill: "url(#paint230_linear_816_5390)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 32.6239H15.6955V34.8585H13.4692V32.6239Z",
    fill: "url(#paint231_linear_816_5390)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 32.6239H22.3744V34.8585H20.1481V32.6239Z",
    fill: "url(#paint232_linear_816_5390)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 32.6239H26.8271V34.8585H24.6007V32.6239Z",
    fill: "url(#paint233_linear_816_5390)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 32.6239H37.9586V34.8585H35.7323V32.6239Z",
    fill: "url(#paint234_linear_816_5390)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 32.6239H46.8638V34.8585H44.6375V32.6239Z",
    fill: "url(#paint235_linear_816_5390)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 32.6239H66.9006V34.8585H64.6743V32.6239Z",
    fill: "url(#paint236_linear_816_5390)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 32.6239H71.3532V34.8585H69.1269V32.6239Z",
    fill: "url(#paint237_linear_816_5390)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 32.6239H78.0321V34.8585H75.8058V32.6239Z",
    fill: "url(#paint238_linear_816_5390)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 32.6239H80.2584V34.8585H78.0321V32.6239Z",
    fill: "url(#paint239_linear_816_5390)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 32.6239H82.4847V34.8585H80.2584V32.6239Z",
    fill: "url(#paint240_linear_816_5390)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 32.6239H84.711V34.8585H82.4847V32.6239Z",
    fill: "url(#paint241_linear_816_5390)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 32.6239H86.9373V34.8585H84.711V32.6239Z",
    fill: "url(#paint242_linear_816_5390)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 32.6239H89.1636V34.8585H86.9373V32.6239Z",
    fill: "url(#paint243_linear_816_5390)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 32.6239H91.39V34.8585H89.1636V32.6239Z",
    fill: "url(#paint244_linear_816_5390)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 32.6239H93.6163V34.8585H91.39V32.6239Z",
    fill: "url(#paint245_linear_816_5390)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 32.6239H100.295V34.8585H98.0689V32.6239Z",
    fill: "url(#paint246_linear_816_5390)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 34.8585H11.2429V37.093H9.0166V34.8585Z",
    fill: "url(#paint247_linear_816_5390)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 34.8585H13.4692V37.093H11.2429V34.8585Z",
    fill: "url(#paint248_linear_816_5390)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 34.8585H17.9218V37.093H15.6955V34.8585Z",
    fill: "url(#paint249_linear_816_5390)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 34.8585H20.1481V37.093H17.9218V34.8585Z",
    fill: "url(#paint250_linear_816_5390)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 34.8585H24.6007V37.093H22.3744V34.8585Z",
    fill: "url(#paint251_linear_816_5390)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 34.8585H26.8271V37.093H24.6007V34.8585Z",
    fill: "url(#paint252_linear_816_5390)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 34.8585H33.506V37.093H31.2797V34.8585Z",
    fill: "url(#paint253_linear_816_5390)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 34.8585H35.7323V37.093H33.506V34.8585Z",
    fill: "url(#paint254_linear_816_5390)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 34.8585H42.4112V37.093H40.1849V34.8585Z",
    fill: "url(#paint255_linear_816_5390)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 34.8585H44.6375V37.093H42.4112V34.8585Z",
    fill: "url(#paint256_linear_816_5390)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 34.8585H46.8638V37.093H44.6375V34.8585Z",
    fill: "url(#paint257_linear_816_5390)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 34.8585H49.0901V37.093H46.8638V34.8585Z",
    fill: "url(#paint258_linear_816_5390)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 34.8585H53.5427V37.093H51.3164V34.8585Z",
    fill: "url(#paint259_linear_816_5390)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 34.8585H60.2217V37.093H57.9954V34.8585Z",
    fill: "url(#paint260_linear_816_5390)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 34.8585H66.9006V37.093H64.6743V34.8585Z",
    fill: "url(#paint261_linear_816_5390)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 34.8585H71.3532V37.093H69.1269V34.8585Z",
    fill: "url(#paint262_linear_816_5390)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 34.8585H75.8058V37.093H73.5795V34.8585Z",
    fill: "url(#paint263_linear_816_5390)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 34.8585H80.2584V37.093H78.0321V34.8585Z",
    fill: "url(#paint264_linear_816_5390)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 34.8585H82.4847V37.093H80.2584V34.8585Z",
    fill: "url(#paint265_linear_816_5390)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 34.8585H86.9373V37.093H84.711V34.8585Z",
    fill: "url(#paint266_linear_816_5390)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 34.8585H93.6163V37.093H91.39V34.8585Z",
    fill: "url(#paint267_linear_816_5390)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 34.8585H95.8426V37.093H93.6163V34.8585Z",
    fill: "url(#paint268_linear_816_5390)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 34.8585H98.0689V37.093H95.8426V34.8585Z",
    fill: "url(#paint269_linear_816_5390)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 37.093H13.4692V39.3275H11.2429V37.093Z",
    fill: "url(#paint270_linear_816_5390)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 37.093H17.9218V39.3275H15.6955V37.093Z",
    fill: "url(#paint271_linear_816_5390)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 37.093H31.2797V39.3275H29.0534V37.093Z",
    fill: "url(#paint272_linear_816_5390)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 37.093H37.9586V39.3275H35.7323V37.093Z",
    fill: "url(#paint273_linear_816_5390)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 37.093H46.8638V39.3275H44.6375V37.093Z",
    fill: "url(#paint274_linear_816_5390)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 37.093H49.0901V39.3275H46.8638V37.093Z",
    fill: "url(#paint275_linear_816_5390)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 37.093H53.5427V39.3275H51.3164V37.093Z",
    fill: "url(#paint276_linear_816_5390)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 37.093H57.9954V39.3275H55.769V37.093Z",
    fill: "url(#paint277_linear_816_5390)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 37.093H62.448V39.3275H60.2217V37.093Z",
    fill: "url(#paint278_linear_816_5390)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 37.093H64.6743V39.3275H62.448V37.093Z",
    fill: "url(#paint279_linear_816_5390)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 37.093H71.3532V39.3275H69.1269V37.093Z",
    fill: "url(#paint280_linear_816_5390)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 37.093H73.5795V39.3275H71.3532V37.093Z",
    fill: "url(#paint281_linear_816_5390)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 37.093H75.8058V39.3275H73.5795V37.093Z",
    fill: "url(#paint282_linear_816_5390)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 37.093H78.0321V39.3275H75.8058V37.093Z",
    fill: "url(#paint283_linear_816_5390)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 37.093H84.711V39.3275H82.4847V37.093Z",
    fill: "url(#paint284_linear_816_5390)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 37.093H89.1636V39.3275H86.9373V37.093Z",
    fill: "url(#paint285_linear_816_5390)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 37.093H91.39V39.3275H89.1636V37.093Z",
    fill: "url(#paint286_linear_816_5390)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 37.093H95.8426V39.3275H93.6163V37.093Z",
    fill: "url(#paint287_linear_816_5390)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 37.093H98.0689V39.3275H95.8426V37.093Z",
    fill: "url(#paint288_linear_816_5390)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 37.093H100.295V39.3275H98.0689V37.093Z",
    fill: "url(#paint289_linear_816_5390)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 39.3275H11.2429V41.562H9.0166V39.3275Z",
    fill: "url(#paint290_linear_816_5390)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 39.3275H13.4692V41.562H11.2429V39.3275Z",
    fill: "url(#paint291_linear_816_5390)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 39.3275H17.9218V41.562H15.6955V39.3275Z",
    fill: "url(#paint292_linear_816_5390)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 39.3275H24.6007V41.562H22.3744V39.3275Z",
    fill: "url(#paint293_linear_816_5390)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 39.3275H26.8271V41.562H24.6007V39.3275Z",
    fill: "url(#paint294_linear_816_5390)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 39.3275H37.9586V41.562H35.7323V39.3275Z",
    fill: "url(#paint295_linear_816_5390)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 39.3275H44.6375V41.562H42.4112V39.3275Z",
    fill: "url(#paint296_linear_816_5390)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 39.3275H49.0901V41.562H46.8638V39.3275Z",
    fill: "url(#paint297_linear_816_5390)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 39.3275H55.769V41.562H53.5427V39.3275Z",
    fill: "url(#paint298_linear_816_5390)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 39.3275H60.2217V41.562H57.9954V39.3275Z",
    fill: "url(#paint299_linear_816_5390)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 39.3275H62.448V41.562H60.2217V39.3275Z",
    fill: "url(#paint300_linear_816_5390)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 39.3275H66.9006V41.562H64.6743V39.3275Z",
    fill: "url(#paint301_linear_816_5390)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 39.3275H69.1269V41.562H66.9006V39.3275Z",
    fill: "url(#paint302_linear_816_5390)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 39.3275H82.4847V41.562H80.2584V39.3275Z",
    fill: "url(#paint303_linear_816_5390)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 39.3275H84.711V41.562H82.4847V39.3275Z",
    fill: "url(#paint304_linear_816_5390)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 39.3275H91.39V41.562H89.1636V39.3275Z",
    fill: "url(#paint305_linear_816_5390)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 41.562H11.2429V43.7965H9.0166V41.562Z",
    fill: "url(#paint306_linear_816_5390)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 41.562H13.4692V43.7965H11.2429V41.562Z",
    fill: "url(#paint307_linear_816_5390)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 41.562H22.3744V43.7965H20.1481V41.562Z",
    fill: "url(#paint308_linear_816_5390)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 41.562H26.8271V43.7965H24.6007V41.562Z",
    fill: "url(#paint309_linear_816_5390)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 41.562H29.0534V43.7965H26.8271V41.562Z",
    fill: "url(#paint310_linear_816_5390)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 41.562H31.2797V43.7965H29.0534V41.562Z",
    fill: "url(#paint311_linear_816_5390)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 41.562H33.506V43.7965H31.2797V41.562Z",
    fill: "url(#paint312_linear_816_5390)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 41.562H35.7323V43.7965H33.506V41.562Z",
    fill: "url(#paint313_linear_816_5390)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 41.562H37.9586V43.7965H35.7323V41.562Z",
    fill: "url(#paint314_linear_816_5390)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 41.562H44.6375V43.7965H42.4112V41.562Z",
    fill: "url(#paint315_linear_816_5390)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 41.562H46.8638V43.7965H44.6375V41.562Z",
    fill: "url(#paint316_linear_816_5390)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 41.562H51.3164V43.7965H49.0901V41.562Z",
    fill: "url(#paint317_linear_816_5390)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 41.562H55.769V43.7965H53.5427V41.562Z",
    fill: "url(#paint318_linear_816_5390)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 41.562H60.2217V43.7965H57.9954V41.562Z",
    fill: "url(#paint319_linear_816_5390)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 41.562H73.5795V43.7965H71.3532V41.562Z",
    fill: "url(#paint320_linear_816_5390)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 41.562H86.9373V43.7965H84.711V41.562Z",
    fill: "url(#paint321_linear_816_5390)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 41.562H91.39V43.7965H89.1636V41.562Z",
    fill: "url(#paint322_linear_816_5390)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 41.562H93.6163V43.7965H91.39V41.562Z",
    fill: "url(#paint323_linear_816_5390)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 41.562H98.0689V43.7965H95.8426V41.562Z",
    fill: "url(#paint324_linear_816_5390)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 41.562H100.295V43.7965H98.0689V41.562Z",
    fill: "url(#paint325_linear_816_5390)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 43.7965H13.4692V46.0311H11.2429V43.7965Z",
    fill: "url(#paint326_linear_816_5390)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 43.7965H15.6955V46.0311H13.4692V43.7965Z",
    fill: "url(#paint327_linear_816_5390)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 43.7965H17.9218V46.0311H15.6955V43.7965Z",
    fill: "url(#paint328_linear_816_5390)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 43.7965H20.1481V46.0311H17.9218V43.7965Z",
    fill: "url(#paint329_linear_816_5390)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 43.7965H22.3744V46.0311H20.1481V43.7965Z",
    fill: "url(#paint330_linear_816_5390)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 43.7965H24.6007V46.0311H22.3744V43.7965Z",
    fill: "url(#paint331_linear_816_5390)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 43.7965H29.0534V46.0311H26.8271V43.7965Z",
    fill: "url(#paint332_linear_816_5390)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 43.7965H31.2797V46.0311H29.0534V43.7965Z",
    fill: "url(#paint333_linear_816_5390)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 43.7965H37.9586V46.0311H35.7323V43.7965Z",
    fill: "url(#paint334_linear_816_5390)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 43.7965H44.6375V46.0311H42.4112V43.7965Z",
    fill: "url(#paint335_linear_816_5390)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 43.7965H49.0901V46.0311H46.8638V43.7965Z",
    fill: "url(#paint336_linear_816_5390)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 43.7965H51.3164V46.0311H49.0901V43.7965Z",
    fill: "url(#paint337_linear_816_5390)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 43.7965H55.769V46.0311H53.5427V43.7965Z",
    fill: "url(#paint338_linear_816_5390)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 43.7965H57.9954V46.0311H55.769V43.7965Z",
    fill: "url(#paint339_linear_816_5390)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 43.7965H66.9006V46.0311H64.6743V43.7965Z",
    fill: "url(#paint340_linear_816_5390)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 43.7965H75.8058V46.0311H73.5795V43.7965Z",
    fill: "url(#paint341_linear_816_5390)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 43.7965H78.0321V46.0311H75.8058V43.7965Z",
    fill: "url(#paint342_linear_816_5390)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 43.7965H84.711V46.0311H82.4847V43.7965Z",
    fill: "url(#paint343_linear_816_5390)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 43.7965H89.1636V46.0311H86.9373V43.7965Z",
    fill: "url(#paint344_linear_816_5390)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 43.7965H95.8426V46.0311H93.6163V43.7965Z",
    fill: "url(#paint345_linear_816_5390)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 46.0311H11.2429V48.2656H9.0166V46.0311Z",
    fill: "url(#paint346_linear_816_5390)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 46.0311H15.6955V48.2656H13.4692V46.0311Z",
    fill: "url(#paint347_linear_816_5390)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 46.0311H17.9218V48.2656H15.6955V46.0311Z",
    fill: "url(#paint348_linear_816_5390)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 46.0311H33.506V48.2656H31.2797V46.0311Z",
    fill: "url(#paint349_linear_816_5390)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 46.0311H40.1849V48.2656H37.9586V46.0311Z",
    fill: "url(#paint350_linear_816_5390)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 46.0311H42.4112V48.2656H40.1849V46.0311Z",
    fill: "url(#paint351_linear_816_5390)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 46.0311H44.6375V48.2656H42.4112V46.0311Z",
    fill: "url(#paint352_linear_816_5390)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 46.0311H51.3164V48.2656H49.0901V46.0311Z",
    fill: "url(#paint353_linear_816_5390)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 46.0311H53.5427V48.2656H51.3164V46.0311Z",
    fill: "url(#paint354_linear_816_5390)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 46.0311H55.769V48.2656H53.5427V46.0311Z",
    fill: "url(#paint355_linear_816_5390)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 46.0311H57.9954V48.2656H55.769V46.0311Z",
    fill: "url(#paint356_linear_816_5390)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 46.0311H60.2217V48.2656H57.9954V46.0311Z",
    fill: "url(#paint357_linear_816_5390)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 46.0311H64.6743V48.2656H62.448V46.0311Z",
    fill: "url(#paint358_linear_816_5390)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 46.0311H66.9006V48.2656H64.6743V46.0311Z",
    fill: "url(#paint359_linear_816_5390)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 46.0311H73.5795V48.2656H71.3532V46.0311Z",
    fill: "url(#paint360_linear_816_5390)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 46.0311H78.0321V48.2656H75.8058V46.0311Z",
    fill: "url(#paint361_linear_816_5390)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 46.0311H80.2584V48.2656H78.0321V46.0311Z",
    fill: "url(#paint362_linear_816_5390)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 46.0311H82.4847V48.2656H80.2584V46.0311Z",
    fill: "url(#paint363_linear_816_5390)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 46.0311H86.9373V48.2656H84.711V46.0311Z",
    fill: "url(#paint364_linear_816_5390)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 46.0311H89.1636V48.2656H86.9373V46.0311Z",
    fill: "url(#paint365_linear_816_5390)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 46.0311H91.39V48.2656H89.1636V46.0311Z",
    fill: "url(#paint366_linear_816_5390)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 46.0311H95.8426V48.2656H93.6163V46.0311Z",
    fill: "url(#paint367_linear_816_5390)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 46.0311H98.0689V48.2656H95.8426V46.0311Z",
    fill: "url(#paint368_linear_816_5390)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 46.0311H100.295V48.2656H98.0689V46.0311Z",
    fill: "url(#paint369_linear_816_5390)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 48.2656H11.2429V50.5001H9.0166V48.2656Z",
    fill: "url(#paint370_linear_816_5390)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 48.2656H15.6955V50.5001H13.4692V48.2656Z",
    fill: "url(#paint371_linear_816_5390)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 48.2656H20.1481V50.5001H17.9218V48.2656Z",
    fill: "url(#paint372_linear_816_5390)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 48.2656H24.6007V50.5001H22.3744V48.2656Z",
    fill: "url(#paint373_linear_816_5390)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 48.2656H29.0534V50.5001H26.8271V48.2656Z",
    fill: "url(#paint374_linear_816_5390)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 48.2656H31.2797V50.5001H29.0534V48.2656Z",
    fill: "url(#paint375_linear_816_5390)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 48.2656H33.506V50.5001H31.2797V48.2656Z",
    fill: "url(#paint376_linear_816_5390)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 48.2656H37.9586V50.5001H35.7323V48.2656Z",
    fill: "url(#paint377_linear_816_5390)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 48.2656H51.3164V50.5001H49.0901V48.2656Z",
    fill: "url(#paint378_linear_816_5390)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 48.2656H53.5427V50.5001H51.3164V48.2656Z",
    fill: "url(#paint379_linear_816_5390)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 48.2656H55.769V50.5001H53.5427V48.2656Z",
    fill: "url(#paint380_linear_816_5390)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 48.2656H62.448V50.5001H60.2217V48.2656Z",
    fill: "url(#paint381_linear_816_5390)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 48.2656H64.6743V50.5001H62.448V48.2656Z",
    fill: "url(#paint382_linear_816_5390)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 48.2656H71.3532V50.5001H69.1269V48.2656Z",
    fill: "url(#paint383_linear_816_5390)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 48.2656H73.5795V50.5001H71.3532V48.2656Z",
    fill: "url(#paint384_linear_816_5390)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 48.2656H78.0321V50.5001H75.8058V48.2656Z",
    fill: "url(#paint385_linear_816_5390)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 48.2656H82.4847V50.5001H80.2584V48.2656Z",
    fill: "url(#paint386_linear_816_5390)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 48.2656H84.711V50.5001H82.4847V48.2656Z",
    fill: "url(#paint387_linear_816_5390)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 48.2656H86.9373V50.5001H84.711V48.2656Z",
    fill: "url(#paint388_linear_816_5390)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 48.2656H91.39V50.5001H89.1636V48.2656Z",
    fill: "url(#paint389_linear_816_5390)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 48.2656H93.6163V50.5001H91.39V48.2656Z",
    fill: "url(#paint390_linear_816_5390)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 50.5001H11.2429V52.7346H9.0166V50.5001Z",
    fill: "url(#paint391_linear_816_5390)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 50.5001H15.6955V52.7346H13.4692V50.5001Z",
    fill: "url(#paint392_linear_816_5390)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 50.5001H22.3744V52.7346H20.1481V50.5001Z",
    fill: "url(#paint393_linear_816_5390)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 50.5001H26.8271V52.7346H24.6007V50.5001Z",
    fill: "url(#paint394_linear_816_5390)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 50.5001H29.0534V52.7346H26.8271V50.5001Z",
    fill: "url(#paint395_linear_816_5390)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 50.5001H31.2797V52.7346H29.0534V50.5001Z",
    fill: "url(#paint396_linear_816_5390)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 50.5001H37.9586V52.7346H35.7323V50.5001Z",
    fill: "url(#paint397_linear_816_5390)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 50.5001H40.1849V52.7346H37.9586V50.5001Z",
    fill: "url(#paint398_linear_816_5390)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 50.5001H46.8638V52.7346H44.6375V50.5001Z",
    fill: "url(#paint399_linear_816_5390)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 50.5001H49.0901V52.7346H46.8638V50.5001Z",
    fill: "url(#paint400_linear_816_5390)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 50.5001H51.3164V52.7346H49.0901V50.5001Z",
    fill: "url(#paint401_linear_816_5390)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 50.5001H60.2217V52.7346H57.9954V50.5001Z",
    fill: "url(#paint402_linear_816_5390)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 50.5001H66.9006V52.7346H64.6743V50.5001Z",
    fill: "url(#paint403_linear_816_5390)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 50.5001H69.1269V52.7346H66.9006V50.5001Z",
    fill: "url(#paint404_linear_816_5390)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 50.5001H71.3532V52.7346H69.1269V50.5001Z",
    fill: "url(#paint405_linear_816_5390)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 50.5001H73.5795V52.7346H71.3532V50.5001Z",
    fill: "url(#paint406_linear_816_5390)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 50.5001H80.2584V52.7346H78.0321V50.5001Z",
    fill: "url(#paint407_linear_816_5390)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 50.5001H91.39V52.7346H89.1636V50.5001Z",
    fill: "url(#paint408_linear_816_5390)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 50.5001H93.6163V52.7346H91.39V50.5001Z",
    fill: "url(#paint409_linear_816_5390)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 50.5001H100.295V52.7346H98.0689V50.5001Z",
    fill: "url(#paint410_linear_816_5390)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 52.7346H15.6955V54.9692H13.4692V52.7346Z",
    fill: "url(#paint411_linear_816_5390)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 52.7346H20.1481V54.9692H17.9218V52.7346Z",
    fill: "url(#paint412_linear_816_5390)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 52.7346H24.6007V54.9692H22.3744V52.7346Z",
    fill: "url(#paint413_linear_816_5390)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 52.7346H26.8271V54.9692H24.6007V52.7346Z",
    fill: "url(#paint414_linear_816_5390)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 52.7346H29.0534V54.9692H26.8271V52.7346Z",
    fill: "url(#paint415_linear_816_5390)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 52.7346H31.2797V54.9692H29.0534V52.7346Z",
    fill: "url(#paint416_linear_816_5390)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 52.7346H33.506V54.9692H31.2797V52.7346Z",
    fill: "url(#paint417_linear_816_5390)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 52.7346H35.7323V54.9692H33.506V52.7346Z",
    fill: "url(#paint418_linear_816_5390)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 52.7346H42.4112V54.9692H40.1849V52.7346Z",
    fill: "url(#paint419_linear_816_5390)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 52.7346H46.8638V54.9692H44.6375V52.7346Z",
    fill: "url(#paint420_linear_816_5390)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 52.7346H57.9954V54.9692H55.769V52.7346Z",
    fill: "url(#paint421_linear_816_5390)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 52.7346H60.2217V54.9692H57.9954V52.7346Z",
    fill: "url(#paint422_linear_816_5390)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 52.7346H62.448V54.9692H60.2217V52.7346Z",
    fill: "url(#paint423_linear_816_5390)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 52.7346H69.1269V54.9692H66.9006V52.7346Z",
    fill: "url(#paint424_linear_816_5390)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 52.7346H71.3532V54.9692H69.1269V52.7346Z",
    fill: "url(#paint425_linear_816_5390)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 52.7346H78.0321V54.9692H75.8058V52.7346Z",
    fill: "url(#paint426_linear_816_5390)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 52.7346H89.1636V54.9692H86.9373V52.7346Z",
    fill: "url(#paint427_linear_816_5390)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 52.7346H91.39V54.9692H89.1636V52.7346Z",
    fill: "url(#paint428_linear_816_5390)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 52.7346H93.6163V54.9692H91.39V52.7346Z",
    fill: "url(#paint429_linear_816_5390)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 52.7346H95.8426V54.9692H93.6163V52.7346Z",
    fill: "url(#paint430_linear_816_5390)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 52.7346H98.0689V54.9692H95.8426V52.7346Z",
    fill: "url(#paint431_linear_816_5390)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 54.9692H11.2429V57.2037H9.0166V54.9692Z",
    fill: "url(#paint432_linear_816_5390)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 54.9692H13.4692V57.2037H11.2429V54.9692Z",
    fill: "url(#paint433_linear_816_5390)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 54.9692H15.6955V57.2037H13.4692V54.9692Z",
    fill: "url(#paint434_linear_816_5390)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 54.9692H17.9218V57.2037H15.6955V54.9692Z",
    fill: "url(#paint435_linear_816_5390)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 54.9692H22.3744V57.2037H20.1481V54.9692Z",
    fill: "url(#paint436_linear_816_5390)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 54.9692H26.8271V57.2037H24.6007V54.9692Z",
    fill: "url(#paint437_linear_816_5390)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 54.9692H29.0534V57.2037H26.8271V54.9692Z",
    fill: "url(#paint438_linear_816_5390)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 54.9692H31.2797V57.2037H29.0534V54.9692Z",
    fill: "url(#paint439_linear_816_5390)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 54.9692H33.506V57.2037H31.2797V54.9692Z",
    fill: "url(#paint440_linear_816_5390)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 54.9692H35.7323V57.2037H33.506V54.9692Z",
    fill: "url(#paint441_linear_816_5390)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 54.9692H44.6375V57.2037H42.4112V54.9692Z",
    fill: "url(#paint442_linear_816_5390)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 54.9692H46.8638V57.2037H44.6375V54.9692Z",
    fill: "url(#paint443_linear_816_5390)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 54.9692H49.0901V57.2037H46.8638V54.9692Z",
    fill: "url(#paint444_linear_816_5390)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 54.9692H60.2217V57.2037H57.9954V54.9692Z",
    fill: "url(#paint445_linear_816_5390)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 54.9692H62.448V57.2037H60.2217V54.9692Z",
    fill: "url(#paint446_linear_816_5390)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 54.9692H64.6743V57.2037H62.448V54.9692Z",
    fill: "url(#paint447_linear_816_5390)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 54.9692H66.9006V57.2037H64.6743V54.9692Z",
    fill: "url(#paint448_linear_816_5390)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 54.9692H69.1269V57.2037H66.9006V54.9692Z",
    fill: "url(#paint449_linear_816_5390)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 54.9692H73.5795V57.2037H71.3532V54.9692Z",
    fill: "url(#paint450_linear_816_5390)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 54.9692H75.8058V57.2037H73.5795V54.9692Z",
    fill: "url(#paint451_linear_816_5390)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 54.9692H80.2584V57.2037H78.0321V54.9692Z",
    fill: "url(#paint452_linear_816_5390)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 54.9692H84.711V57.2037H82.4847V54.9692Z",
    fill: "url(#paint453_linear_816_5390)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 54.9692H86.9373V57.2037H84.711V54.9692Z",
    fill: "url(#paint454_linear_816_5390)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 54.9692H91.39V57.2037H89.1636V54.9692Z",
    fill: "url(#paint455_linear_816_5390)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 54.9692H93.6163V57.2037H91.39V54.9692Z",
    fill: "url(#paint456_linear_816_5390)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 54.9692H95.8426V57.2037H93.6163V54.9692Z",
    fill: "url(#paint457_linear_816_5390)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 54.9692H98.0689V57.2037H95.8426V54.9692Z",
    fill: "url(#paint458_linear_816_5390)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 54.9692H100.295V57.2037H98.0689V54.9692Z",
    fill: "url(#paint459_linear_816_5390)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 57.2037H15.6955V59.4382H13.4692V57.2037Z",
    fill: "url(#paint460_linear_816_5390)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 57.2037H17.9218V59.4382H15.6955V57.2037Z",
    fill: "url(#paint461_linear_816_5390)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 57.2037H22.3744V59.4382H20.1481V57.2037Z",
    fill: "url(#paint462_linear_816_5390)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 57.2037H24.6007V59.4382H22.3744V57.2037Z",
    fill: "url(#paint463_linear_816_5390)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 57.2037H26.8271V59.4382H24.6007V57.2037Z",
    fill: "url(#paint464_linear_816_5390)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 57.2037H29.0534V59.4382H26.8271V57.2037Z",
    fill: "url(#paint465_linear_816_5390)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 57.2037H31.2797V59.4382H29.0534V57.2037Z",
    fill: "url(#paint466_linear_816_5390)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 57.2037H37.9586V59.4382H35.7323V57.2037Z",
    fill: "url(#paint467_linear_816_5390)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 57.2037H40.1849V59.4382H37.9586V57.2037Z",
    fill: "url(#paint468_linear_816_5390)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 57.2037H44.6375V59.4382H42.4112V57.2037Z",
    fill: "url(#paint469_linear_816_5390)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 57.2037H55.769V59.4382H53.5427V57.2037Z",
    fill: "url(#paint470_linear_816_5390)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 57.2037H60.2217V59.4382H57.9954V57.2037Z",
    fill: "url(#paint471_linear_816_5390)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 57.2037H62.448V59.4382H60.2217V57.2037Z",
    fill: "url(#paint472_linear_816_5390)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 57.2037H64.6743V59.4382H62.448V57.2037Z",
    fill: "url(#paint473_linear_816_5390)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 57.2037H66.9006V59.4382H64.6743V57.2037Z",
    fill: "url(#paint474_linear_816_5390)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 57.2037H71.3532V59.4382H69.1269V57.2037Z",
    fill: "url(#paint475_linear_816_5390)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 57.2037H75.8058V59.4382H73.5795V57.2037Z",
    fill: "url(#paint476_linear_816_5390)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 57.2037H84.711V59.4382H82.4847V57.2037Z",
    fill: "url(#paint477_linear_816_5390)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 57.2037H89.1636V59.4382H86.9373V57.2037Z",
    fill: "url(#paint478_linear_816_5390)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 57.2037H91.39V59.4382H89.1636V57.2037Z",
    fill: "url(#paint479_linear_816_5390)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 57.2037H93.6163V59.4382H91.39V57.2037Z",
    fill: "url(#paint480_linear_816_5390)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 57.2037H95.8426V59.4382H93.6163V57.2037Z",
    fill: "url(#paint481_linear_816_5390)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 59.4382H17.9218V61.6727H15.6955V59.4382Z",
    fill: "url(#paint482_linear_816_5390)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 59.4382H22.3744V61.6727H20.1481V59.4382Z",
    fill: "url(#paint483_linear_816_5390)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 59.4382H29.0534V61.6727H26.8271V59.4382Z",
    fill: "url(#paint484_linear_816_5390)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 59.4382H35.7323V61.6727H33.506V59.4382Z",
    fill: "url(#paint485_linear_816_5390)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 59.4382H42.4112V61.6727H40.1849V59.4382Z",
    fill: "url(#paint486_linear_816_5390)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 59.4382H44.6375V61.6727H42.4112V59.4382Z",
    fill: "url(#paint487_linear_816_5390)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 59.4382H49.0901V61.6727H46.8638V59.4382Z",
    fill: "url(#paint488_linear_816_5390)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 59.4382H51.3164V61.6727H49.0901V59.4382Z",
    fill: "url(#paint489_linear_816_5390)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 59.4382H55.769V61.6727H53.5427V59.4382Z",
    fill: "url(#paint490_linear_816_5390)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 59.4382H57.9954V61.6727H55.769V59.4382Z",
    fill: "url(#paint491_linear_816_5390)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 59.4382H64.6743V61.6727H62.448V59.4382Z",
    fill: "url(#paint492_linear_816_5390)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 59.4382H66.9006V61.6727H64.6743V59.4382Z",
    fill: "url(#paint493_linear_816_5390)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 59.4382H69.1269V61.6727H66.9006V59.4382Z",
    fill: "url(#paint494_linear_816_5390)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 59.4382H78.0321V61.6727H75.8058V59.4382Z",
    fill: "url(#paint495_linear_816_5390)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 59.4382H80.2584V61.6727H78.0321V59.4382Z",
    fill: "url(#paint496_linear_816_5390)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 59.4382H82.4847V61.6727H80.2584V59.4382Z",
    fill: "url(#paint497_linear_816_5390)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 59.4382H84.711V61.6727H82.4847V59.4382Z",
    fill: "url(#paint498_linear_816_5390)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 59.4382H86.9373V61.6727H84.711V59.4382Z",
    fill: "url(#paint499_linear_816_5390)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 59.4382H91.39V61.6727H89.1636V59.4382Z",
    fill: "url(#paint500_linear_816_5390)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 59.4382H98.0689V61.6727H95.8426V59.4382Z",
    fill: "url(#paint501_linear_816_5390)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 59.4382H100.295V61.6727H98.0689V59.4382Z",
    fill: "url(#paint502_linear_816_5390)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 61.6727H11.2429V63.9072H9.0166V61.6727Z",
    fill: "url(#paint503_linear_816_5390)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 61.6727H13.4692V63.9072H11.2429V61.6727Z",
    fill: "url(#paint504_linear_816_5390)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 61.6727H15.6955V63.9072H13.4692V61.6727Z",
    fill: "url(#paint505_linear_816_5390)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 61.6727H22.3744V63.9072H20.1481V61.6727Z",
    fill: "url(#paint506_linear_816_5390)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 61.6727H24.6007V63.9072H22.3744V61.6727Z",
    fill: "url(#paint507_linear_816_5390)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 61.6727H31.2797V63.9072H29.0534V61.6727Z",
    fill: "url(#paint508_linear_816_5390)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 61.6727H35.7323V63.9072H33.506V61.6727Z",
    fill: "url(#paint509_linear_816_5390)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 61.6727H40.1849V63.9072H37.9586V61.6727Z",
    fill: "url(#paint510_linear_816_5390)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 61.6727H42.4112V63.9072H40.1849V61.6727Z",
    fill: "url(#paint511_linear_816_5390)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 61.6727H46.8638V63.9072H44.6375V61.6727Z",
    fill: "url(#paint512_linear_816_5390)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 61.6727H49.0901V63.9072H46.8638V61.6727Z",
    fill: "url(#paint513_linear_816_5390)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 61.6727H51.3164V63.9072H49.0901V61.6727Z",
    fill: "url(#paint514_linear_816_5390)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 61.6727H55.769V63.9072H53.5427V61.6727Z",
    fill: "url(#paint515_linear_816_5390)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 61.6727H60.2217V63.9072H57.9954V61.6727Z",
    fill: "url(#paint516_linear_816_5390)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 61.6727H62.448V63.9072H60.2217V61.6727Z",
    fill: "url(#paint517_linear_816_5390)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 61.6727H64.6743V63.9072H62.448V61.6727Z",
    fill: "url(#paint518_linear_816_5390)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 61.6727H66.9006V63.9072H64.6743V61.6727Z",
    fill: "url(#paint519_linear_816_5390)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 61.6727H69.1269V63.9072H66.9006V61.6727Z",
    fill: "url(#paint520_linear_816_5390)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 61.6727H71.3532V63.9072H69.1269V61.6727Z",
    fill: "url(#paint521_linear_816_5390)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 61.6727H73.5795V63.9072H71.3532V61.6727Z",
    fill: "url(#paint522_linear_816_5390)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 61.6727H75.8058V63.9072H73.5795V61.6727Z",
    fill: "url(#paint523_linear_816_5390)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 61.6727H80.2584V63.9072H78.0321V61.6727Z",
    fill: "url(#paint524_linear_816_5390)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 61.6727H84.711V63.9072H82.4847V61.6727Z",
    fill: "url(#paint525_linear_816_5390)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 61.6727H100.295V63.9072H98.0689V61.6727Z",
    fill: "url(#paint526_linear_816_5390)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 63.9072H11.2429V66.1418H9.0166V63.9072Z",
    fill: "url(#paint527_linear_816_5390)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 63.9072H17.9218V66.1418H15.6955V63.9072Z",
    fill: "url(#paint528_linear_816_5390)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 63.9072H31.2797V66.1418H29.0534V63.9072Z",
    fill: "url(#paint529_linear_816_5390)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 63.9072H33.506V66.1418H31.2797V63.9072Z",
    fill: "url(#paint530_linear_816_5390)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 63.9072H37.9586V66.1418H35.7323V63.9072Z",
    fill: "url(#paint531_linear_816_5390)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 63.9072H40.1849V66.1418H37.9586V63.9072Z",
    fill: "url(#paint532_linear_816_5390)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 63.9072H42.4112V66.1418H40.1849V63.9072Z",
    fill: "url(#paint533_linear_816_5390)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 63.9072H44.6375V66.1418H42.4112V63.9072Z",
    fill: "url(#paint534_linear_816_5390)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 63.9072H46.8638V66.1418H44.6375V63.9072Z",
    fill: "url(#paint535_linear_816_5390)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 63.9072H49.0901V66.1418H46.8638V63.9072Z",
    fill: "url(#paint536_linear_816_5390)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 63.9072H53.5427V66.1418H51.3164V63.9072Z",
    fill: "url(#paint537_linear_816_5390)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 63.9072H60.2217V66.1418H57.9954V63.9072Z",
    fill: "url(#paint538_linear_816_5390)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 63.9072H62.448V66.1418H60.2217V63.9072Z",
    fill: "url(#paint539_linear_816_5390)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 63.9072H73.5795V66.1418H71.3532V63.9072Z",
    fill: "url(#paint540_linear_816_5390)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 63.9072H75.8058V66.1418H73.5795V63.9072Z",
    fill: "url(#paint541_linear_816_5390)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 63.9072H78.0321V66.1418H75.8058V63.9072Z",
    fill: "url(#paint542_linear_816_5390)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 63.9072H80.2584V66.1418H78.0321V63.9072Z",
    fill: "url(#paint543_linear_816_5390)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 63.9072H84.711V66.1418H82.4847V63.9072Z",
    fill: "url(#paint544_linear_816_5390)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 63.9072H86.9373V66.1418H84.711V63.9072Z",
    fill: "url(#paint545_linear_816_5390)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 63.9072H89.1636V66.1418H86.9373V63.9072Z",
    fill: "url(#paint546_linear_816_5390)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 63.9072H91.39V66.1418H89.1636V63.9072Z",
    fill: "url(#paint547_linear_816_5390)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 63.9072H93.6163V66.1418H91.39V63.9072Z",
    fill: "url(#paint548_linear_816_5390)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 63.9072H100.295V66.1418H98.0689V63.9072Z",
    fill: "url(#paint549_linear_816_5390)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 66.1418H11.2429V68.3763H9.0166V66.1418Z",
    fill: "url(#paint550_linear_816_5390)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 66.1418H15.6955V68.3763H13.4692V66.1418Z",
    fill: "url(#paint551_linear_816_5390)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 66.1418H24.6007V68.3763H22.3744V66.1418Z",
    fill: "url(#paint552_linear_816_5390)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 66.1418H26.8271V68.3763H24.6007V66.1418Z",
    fill: "url(#paint553_linear_816_5390)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 66.1418H29.0534V68.3763H26.8271V66.1418Z",
    fill: "url(#paint554_linear_816_5390)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 66.1418H35.7323V68.3763H33.506V66.1418Z",
    fill: "url(#paint555_linear_816_5390)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 66.1418H44.6375V68.3763H42.4112V66.1418Z",
    fill: "url(#paint556_linear_816_5390)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 66.1418H46.8638V68.3763H44.6375V66.1418Z",
    fill: "url(#paint557_linear_816_5390)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 66.1418H49.0901V68.3763H46.8638V66.1418Z",
    fill: "url(#paint558_linear_816_5390)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 66.1418H53.5427V68.3763H51.3164V66.1418Z",
    fill: "url(#paint559_linear_816_5390)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 66.1418H55.769V68.3763H53.5427V66.1418Z",
    fill: "url(#paint560_linear_816_5390)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 66.1418H57.9954V68.3763H55.769V66.1418Z",
    fill: "url(#paint561_linear_816_5390)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 66.1418H62.448V68.3763H60.2217V66.1418Z",
    fill: "url(#paint562_linear_816_5390)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 66.1418H66.9006V68.3763H64.6743V66.1418Z",
    fill: "url(#paint563_linear_816_5390)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 66.1418H69.1269V68.3763H66.9006V66.1418Z",
    fill: "url(#paint564_linear_816_5390)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 66.1418H71.3532V68.3763H69.1269V66.1418Z",
    fill: "url(#paint565_linear_816_5390)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 66.1418H73.5795V68.3763H71.3532V66.1418Z",
    fill: "url(#paint566_linear_816_5390)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 66.1418H78.0321V68.3763H75.8058V66.1418Z",
    fill: "url(#paint567_linear_816_5390)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 66.1418H82.4847V68.3763H80.2584V66.1418Z",
    fill: "url(#paint568_linear_816_5390)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 66.1418H84.711V68.3763H82.4847V66.1418Z",
    fill: "url(#paint569_linear_816_5390)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 66.1418H91.39V68.3763H89.1636V66.1418Z",
    fill: "url(#paint570_linear_816_5390)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 68.3763H11.2429V70.6108H9.0166V68.3763Z",
    fill: "url(#paint571_linear_816_5390)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 68.3763H15.6955V70.6108H13.4692V68.3763Z",
    fill: "url(#paint572_linear_816_5390)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 68.3763H17.9218V70.6108H15.6955V68.3763Z",
    fill: "url(#paint573_linear_816_5390)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 68.3763H20.1481V70.6108H17.9218V68.3763Z",
    fill: "url(#paint574_linear_816_5390)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 68.3763H29.0534V70.6108H26.8271V68.3763Z",
    fill: "url(#paint575_linear_816_5390)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 68.3763H31.2797V70.6108H29.0534V68.3763Z",
    fill: "url(#paint576_linear_816_5390)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 68.3763H33.506V70.6108H31.2797V68.3763Z",
    fill: "url(#paint577_linear_816_5390)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 68.3763H35.7323V70.6108H33.506V68.3763Z",
    fill: "url(#paint578_linear_816_5390)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 68.3763H40.1849V70.6108H37.9586V68.3763Z",
    fill: "url(#paint579_linear_816_5390)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 68.3763H46.8638V70.6108H44.6375V68.3763Z",
    fill: "url(#paint580_linear_816_5390)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 68.3763H51.3164V70.6108H49.0901V68.3763Z",
    fill: "url(#paint581_linear_816_5390)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 68.3763H62.448V70.6108H60.2217V68.3763Z",
    fill: "url(#paint582_linear_816_5390)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 68.3763H66.9006V70.6108H64.6743V68.3763Z",
    fill: "url(#paint583_linear_816_5390)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 68.3763H69.1269V70.6108H66.9006V68.3763Z",
    fill: "url(#paint584_linear_816_5390)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 68.3763H71.3532V70.6108H69.1269V68.3763Z",
    fill: "url(#paint585_linear_816_5390)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 68.3763H78.0321V70.6108H75.8058V68.3763Z",
    fill: "url(#paint586_linear_816_5390)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 68.3763H80.2584V70.6108H78.0321V68.3763Z",
    fill: "url(#paint587_linear_816_5390)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 68.3763H82.4847V70.6108H80.2584V68.3763Z",
    fill: "url(#paint588_linear_816_5390)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 68.3763H93.6163V70.6108H91.39V68.3763Z",
    fill: "url(#paint589_linear_816_5390)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 68.3763H98.0689V70.6108H95.8426V68.3763Z",
    fill: "url(#paint590_linear_816_5390)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 70.6108H13.4692V72.8453H11.2429V70.6108Z",
    fill: "url(#paint591_linear_816_5390)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 70.6108H15.6955V72.8453H13.4692V70.6108Z",
    fill: "url(#paint592_linear_816_5390)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 70.6108H17.9218V72.8453H15.6955V70.6108Z",
    fill: "url(#paint593_linear_816_5390)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 70.6108H20.1481V72.8453H17.9218V70.6108Z",
    fill: "url(#paint594_linear_816_5390)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 70.6108H24.6007V72.8453H22.3744V70.6108Z",
    fill: "url(#paint595_linear_816_5390)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 70.6108H26.8271V72.8453H24.6007V70.6108Z",
    fill: "url(#paint596_linear_816_5390)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 70.6108H42.4112V72.8453H40.1849V70.6108Z",
    fill: "url(#paint597_linear_816_5390)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 70.6108H44.6375V72.8453H42.4112V70.6108Z",
    fill: "url(#paint598_linear_816_5390)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 70.6108H46.8638V72.8453H44.6375V70.6108Z",
    fill: "url(#paint599_linear_816_5390)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 70.6108H53.5427V72.8453H51.3164V70.6108Z",
    fill: "url(#paint600_linear_816_5390)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 70.6108H55.769V72.8453H53.5427V70.6108Z",
    fill: "url(#paint601_linear_816_5390)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 70.6108H60.2217V72.8453H57.9954V70.6108Z",
    fill: "url(#paint602_linear_816_5390)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 70.6108H64.6743V72.8453H62.448V70.6108Z",
    fill: "url(#paint603_linear_816_5390)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 70.6108H71.3532V72.8453H69.1269V70.6108Z",
    fill: "url(#paint604_linear_816_5390)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 70.6108H73.5795V72.8453H71.3532V70.6108Z",
    fill: "url(#paint605_linear_816_5390)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 70.6108H75.8058V72.8453H73.5795V70.6108Z",
    fill: "url(#paint606_linear_816_5390)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 70.6108H80.2584V72.8453H78.0321V70.6108Z",
    fill: "url(#paint607_linear_816_5390)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 70.6108H84.711V72.8453H82.4847V70.6108Z",
    fill: "url(#paint608_linear_816_5390)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 70.6108H89.1636V72.8453H86.9373V70.6108Z",
    fill: "url(#paint609_linear_816_5390)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 70.6108H93.6163V72.8453H91.39V70.6108Z",
    fill: "url(#paint610_linear_816_5390)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 70.6108H95.8426V72.8453H93.6163V70.6108Z",
    fill: "url(#paint611_linear_816_5390)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 72.8453H11.2429V75.0799H9.0166V72.8453Z",
    fill: "url(#paint612_linear_816_5390)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 72.8453H13.4692V75.0799H11.2429V72.8453Z",
    fill: "url(#paint613_linear_816_5390)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 72.8453H20.1481V75.0799H17.9218V72.8453Z",
    fill: "url(#paint614_linear_816_5390)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 72.8453H29.0534V75.0799H26.8271V72.8453Z",
    fill: "url(#paint615_linear_816_5390)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 72.8453H31.2797V75.0799H29.0534V72.8453Z",
    fill: "url(#paint616_linear_816_5390)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 72.8453H35.7323V75.0799H33.506V72.8453Z",
    fill: "url(#paint617_linear_816_5390)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 72.8453H51.3164V75.0799H49.0901V72.8453Z",
    fill: "url(#paint618_linear_816_5390)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 72.8453H53.5427V75.0799H51.3164V72.8453Z",
    fill: "url(#paint619_linear_816_5390)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 72.8453H55.769V75.0799H53.5427V72.8453Z",
    fill: "url(#paint620_linear_816_5390)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 72.8453H57.9954V75.0799H55.769V72.8453Z",
    fill: "url(#paint621_linear_816_5390)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 72.8453H71.3532V75.0799H69.1269V72.8453Z",
    fill: "url(#paint622_linear_816_5390)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 72.8453H75.8058V75.0799H73.5795V72.8453Z",
    fill: "url(#paint623_linear_816_5390)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 72.8453H78.0321V75.0799H75.8058V72.8453Z",
    fill: "url(#paint624_linear_816_5390)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 72.8453H82.4847V75.0799H80.2584V72.8453Z",
    fill: "url(#paint625_linear_816_5390)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 72.8453H89.1636V75.0799H86.9373V72.8453Z",
    fill: "url(#paint626_linear_816_5390)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 72.8453H91.39V75.0799H89.1636V72.8453Z",
    fill: "url(#paint627_linear_816_5390)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 72.8453H98.0689V75.0799H95.8426V72.8453Z",
    fill: "url(#paint628_linear_816_5390)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 72.8453H100.295V75.0799H98.0689V72.8453Z",
    fill: "url(#paint629_linear_816_5390)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 75.0799H11.2429V77.3144H9.0166V75.0799Z",
    fill: "url(#paint630_linear_816_5390)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 75.0799H24.6007V77.3144H22.3744V75.0799Z",
    fill: "url(#paint631_linear_816_5390)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 75.0799H31.2797V77.3144H29.0534V75.0799Z",
    fill: "url(#paint632_linear_816_5390)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 75.0799H35.7323V77.3144H33.506V75.0799Z",
    fill: "url(#paint633_linear_816_5390)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 75.0799H40.1849V77.3144H37.9586V75.0799Z",
    fill: "url(#paint634_linear_816_5390)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 75.0799H46.8638V77.3144H44.6375V75.0799Z",
    fill: "url(#paint635_linear_816_5390)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 75.0799H49.0901V77.3144H46.8638V75.0799Z",
    fill: "url(#paint636_linear_816_5390)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 75.0799H51.3164V77.3144H49.0901V75.0799Z",
    fill: "url(#paint637_linear_816_5390)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 75.0799H53.5427V77.3144H51.3164V75.0799Z",
    fill: "url(#paint638_linear_816_5390)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 75.0799H60.2217V77.3144H57.9954V75.0799Z",
    fill: "url(#paint639_linear_816_5390)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 75.0799H62.448V77.3144H60.2217V75.0799Z",
    fill: "url(#paint640_linear_816_5390)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 75.0799H66.9006V77.3144H64.6743V75.0799Z",
    fill: "url(#paint641_linear_816_5390)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 75.0799H69.1269V77.3144H66.9006V75.0799Z",
    fill: "url(#paint642_linear_816_5390)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 75.0799H71.3532V77.3144H69.1269V75.0799Z",
    fill: "url(#paint643_linear_816_5390)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 75.0799H73.5795V77.3144H71.3532V75.0799Z",
    fill: "url(#paint644_linear_816_5390)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 75.0799H75.8058V77.3144H73.5795V75.0799Z",
    fill: "url(#paint645_linear_816_5390)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 75.0799H80.2584V77.3144H78.0321V75.0799Z",
    fill: "url(#paint646_linear_816_5390)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 75.0799H84.711V77.3144H82.4847V75.0799Z",
    fill: "url(#paint647_linear_816_5390)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 75.0799H86.9373V77.3144H84.711V75.0799Z",
    fill: "url(#paint648_linear_816_5390)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 75.0799H89.1636V77.3144H86.9373V75.0799Z",
    fill: "url(#paint649_linear_816_5390)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 75.0799H91.39V77.3144H89.1636V75.0799Z",
    fill: "url(#paint650_linear_816_5390)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 75.0799H93.6163V77.3144H91.39V75.0799Z",
    fill: "url(#paint651_linear_816_5390)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 77.3144H11.2429V79.5489H9.0166V77.3144Z",
    fill: "url(#paint652_linear_816_5390)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 77.3144H15.6955V79.5489H13.4692V77.3144Z",
    fill: "url(#paint653_linear_816_5390)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 77.3144H22.3744V79.5489H20.1481V77.3144Z",
    fill: "url(#paint654_linear_816_5390)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 77.3144H29.0534V79.5489H26.8271V77.3144Z",
    fill: "url(#paint655_linear_816_5390)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 77.3144H33.506V79.5489H31.2797V77.3144Z",
    fill: "url(#paint656_linear_816_5390)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 77.3144H35.7323V79.5489H33.506V77.3144Z",
    fill: "url(#paint657_linear_816_5390)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 77.3144H40.1849V79.5489H37.9586V77.3144Z",
    fill: "url(#paint658_linear_816_5390)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 77.3144H42.4112V79.5489H40.1849V77.3144Z",
    fill: "url(#paint659_linear_816_5390)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 77.3144H46.8638V79.5489H44.6375V77.3144Z",
    fill: "url(#paint660_linear_816_5390)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 77.3144H51.3164V79.5489H49.0901V77.3144Z",
    fill: "url(#paint661_linear_816_5390)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 77.3144H60.2217V79.5489H57.9954V77.3144Z",
    fill: "url(#paint662_linear_816_5390)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 77.3144H62.448V79.5489H60.2217V77.3144Z",
    fill: "url(#paint663_linear_816_5390)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 77.3144H66.9006V79.5489H64.6743V77.3144Z",
    fill: "url(#paint664_linear_816_5390)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 77.3144H71.3532V79.5489H69.1269V77.3144Z",
    fill: "url(#paint665_linear_816_5390)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 77.3144H80.2584V79.5489H78.0321V77.3144Z",
    fill: "url(#paint666_linear_816_5390)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 77.3144H82.4847V79.5489H80.2584V77.3144Z",
    fill: "url(#paint667_linear_816_5390)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 77.3144H84.711V79.5489H82.4847V77.3144Z",
    fill: "url(#paint668_linear_816_5390)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 77.3144H86.9373V79.5489H84.711V77.3144Z",
    fill: "url(#paint669_linear_816_5390)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 77.3144H89.1636V79.5489H86.9373V77.3144Z",
    fill: "url(#paint670_linear_816_5390)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 77.3144H93.6163V79.5489H91.39V77.3144Z",
    fill: "url(#paint671_linear_816_5390)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 77.3144H100.295V79.5489H98.0689V77.3144Z",
    fill: "url(#paint672_linear_816_5390)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 79.5489H11.2429V81.7834H9.0166V79.5489Z",
    fill: "url(#paint673_linear_816_5390)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 79.5489H17.9218V81.7834H15.6955V79.5489Z",
    fill: "url(#paint674_linear_816_5390)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 79.5489H20.1481V81.7834H17.9218V79.5489Z",
    fill: "url(#paint675_linear_816_5390)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 79.5489H24.6007V81.7834H22.3744V79.5489Z",
    fill: "url(#paint676_linear_816_5390)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 79.5489H29.0534V81.7834H26.8271V79.5489Z",
    fill: "url(#paint677_linear_816_5390)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 79.5489H33.506V81.7834H31.2797V79.5489Z",
    fill: "url(#paint678_linear_816_5390)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 79.5489H40.1849V81.7834H37.9586V79.5489Z",
    fill: "url(#paint679_linear_816_5390)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 79.5489H46.8638V81.7834H44.6375V79.5489Z",
    fill: "url(#paint680_linear_816_5390)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 79.5489H49.0901V81.7834H46.8638V79.5489Z",
    fill: "url(#paint681_linear_816_5390)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 79.5489H51.3164V81.7834H49.0901V79.5489Z",
    fill: "url(#paint682_linear_816_5390)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 79.5489H55.769V81.7834H53.5427V79.5489Z",
    fill: "url(#paint683_linear_816_5390)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 79.5489H57.9954V81.7834H55.769V79.5489Z",
    fill: "url(#paint684_linear_816_5390)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 79.5489H60.2217V81.7834H57.9954V79.5489Z",
    fill: "url(#paint685_linear_816_5390)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 79.5489H64.6743V81.7834H62.448V79.5489Z",
    fill: "url(#paint686_linear_816_5390)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 79.5489H66.9006V81.7834H64.6743V79.5489Z",
    fill: "url(#paint687_linear_816_5390)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 79.5489H69.1269V81.7834H66.9006V79.5489Z",
    fill: "url(#paint688_linear_816_5390)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 79.5489H71.3532V81.7834H69.1269V79.5489Z",
    fill: "url(#paint689_linear_816_5390)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 79.5489H75.8058V81.7834H73.5795V79.5489Z",
    fill: "url(#paint690_linear_816_5390)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 79.5489H80.2584V81.7834H78.0321V79.5489Z",
    fill: "url(#paint691_linear_816_5390)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 79.5489H82.4847V81.7834H80.2584V79.5489Z",
    fill: "url(#paint692_linear_816_5390)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 79.5489H84.711V81.7834H82.4847V79.5489Z",
    fill: "url(#paint693_linear_816_5390)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 79.5489H86.9373V81.7834H84.711V79.5489Z",
    fill: "url(#paint694_linear_816_5390)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 79.5489H89.1636V81.7834H86.9373V79.5489Z",
    fill: "url(#paint695_linear_816_5390)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 79.5489H91.39V81.7834H89.1636V79.5489Z",
    fill: "url(#paint696_linear_816_5390)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 79.5489H95.8426V81.7834H93.6163V79.5489Z",
    fill: "url(#paint697_linear_816_5390)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 79.5489H100.295V81.7834H98.0689V79.5489Z",
    fill: "url(#paint698_linear_816_5390)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 81.7834H29.0534V84.0179H26.8271V81.7834Z",
    fill: "url(#paint699_linear_816_5390)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 81.7834H31.2797V84.0179H29.0534V81.7834Z",
    fill: "url(#paint700_linear_816_5390)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 81.7834H37.9586V84.0179H35.7323V81.7834Z",
    fill: "url(#paint701_linear_816_5390)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 81.7834H51.3164V84.0179H49.0901V81.7834Z",
    fill: "url(#paint702_linear_816_5390)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 81.7834H53.5427V84.0179H51.3164V81.7834Z",
    fill: "url(#paint703_linear_816_5390)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 81.7834H57.9954V84.0179H55.769V81.7834Z",
    fill: "url(#paint704_linear_816_5390)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 81.7834H64.6743V84.0179H62.448V81.7834Z",
    fill: "url(#paint705_linear_816_5390)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 81.7834H66.9006V84.0179H64.6743V81.7834Z",
    fill: "url(#paint706_linear_816_5390)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 81.7834H69.1269V84.0179H66.9006V81.7834Z",
    fill: "url(#paint707_linear_816_5390)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 81.7834H73.5795V84.0179H71.3532V81.7834Z",
    fill: "url(#paint708_linear_816_5390)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 81.7834H75.8058V84.0179H73.5795V81.7834Z",
    fill: "url(#paint709_linear_816_5390)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 81.7834H78.0321V84.0179H75.8058V81.7834Z",
    fill: "url(#paint710_linear_816_5390)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 81.7834H82.4847V84.0179H80.2584V81.7834Z",
    fill: "url(#paint711_linear_816_5390)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 81.7834H91.39V84.0179H89.1636V81.7834Z",
    fill: "url(#paint712_linear_816_5390)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 81.7834H98.0689V84.0179H95.8426V81.7834Z",
    fill: "url(#paint713_linear_816_5390)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 81.7834H100.295V84.0179H98.0689V81.7834Z",
    fill: "url(#paint714_linear_816_5390)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 84.0179H11.2429V86.2525H9.0166V84.0179Z",
    fill: "url(#paint715_linear_816_5390)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 84.0179H13.4692V86.2525H11.2429V84.0179Z",
    fill: "url(#paint716_linear_816_5390)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 84.0179H15.6955V86.2525H13.4692V84.0179Z",
    fill: "url(#paint717_linear_816_5390)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 84.0179H17.9218V86.2525H15.6955V84.0179Z",
    fill: "url(#paint718_linear_816_5390)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 84.0179H20.1481V86.2525H17.9218V84.0179Z",
    fill: "url(#paint719_linear_816_5390)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 84.0179H22.3744V86.2525H20.1481V84.0179Z",
    fill: "url(#paint720_linear_816_5390)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 84.0179H24.6007V86.2525H22.3744V84.0179Z",
    fill: "url(#paint721_linear_816_5390)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 84.0179H33.506V86.2525H31.2797V84.0179Z",
    fill: "url(#paint722_linear_816_5390)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 84.0179H42.4112V86.2525H40.1849V84.0179Z",
    fill: "url(#paint723_linear_816_5390)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 84.0179H44.6375V86.2525H42.4112V84.0179Z",
    fill: "url(#paint724_linear_816_5390)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 84.0179H46.8638V86.2525H44.6375V84.0179Z",
    fill: "url(#paint725_linear_816_5390)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 84.0179H49.0901V86.2525H46.8638V84.0179Z",
    fill: "url(#paint726_linear_816_5390)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 84.0179H51.3164V86.2525H49.0901V84.0179Z",
    fill: "url(#paint727_linear_816_5390)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 84.0179H53.5427V86.2525H51.3164V84.0179Z",
    fill: "url(#paint728_linear_816_5390)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 84.0179H57.9954V86.2525H55.769V84.0179Z",
    fill: "url(#paint729_linear_816_5390)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 84.0179H60.2217V86.2525H57.9954V84.0179Z",
    fill: "url(#paint730_linear_816_5390)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 84.0179H62.448V86.2525H60.2217V84.0179Z",
    fill: "url(#paint731_linear_816_5390)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 84.0179H64.6743V86.2525H62.448V84.0179Z",
    fill: "url(#paint732_linear_816_5390)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 84.0179H66.9006V86.2525H64.6743V84.0179Z",
    fill: "url(#paint733_linear_816_5390)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 84.0179H69.1269V86.2525H66.9006V84.0179Z",
    fill: "url(#paint734_linear_816_5390)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 84.0179H71.3532V86.2525H69.1269V84.0179Z",
    fill: "url(#paint735_linear_816_5390)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 84.0179H75.8058V86.2525H73.5795V84.0179Z",
    fill: "url(#paint736_linear_816_5390)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 84.0179H80.2584V86.2525H78.0321V84.0179Z",
    fill: "url(#paint737_linear_816_5390)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 84.0179H82.4847V86.2525H80.2584V84.0179Z",
    fill: "url(#paint738_linear_816_5390)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 84.0179H86.9373V86.2525H84.711V84.0179Z",
    fill: "url(#paint739_linear_816_5390)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 84.0179H91.39V86.2525H89.1636V84.0179Z",
    fill: "url(#paint740_linear_816_5390)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 84.0179H93.6163V86.2525H91.39V84.0179Z",
    fill: "url(#paint741_linear_816_5390)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 84.0179H95.8426V86.2525H93.6163V84.0179Z",
    fill: "url(#paint742_linear_816_5390)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 86.2525H11.2429V88.487H9.0166V86.2525Z",
    fill: "url(#paint743_linear_816_5390)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 86.2525H24.6007V88.487H22.3744V86.2525Z",
    fill: "url(#paint744_linear_816_5390)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 86.2525H31.2797V88.487H29.0534V86.2525Z",
    fill: "url(#paint745_linear_816_5390)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 86.2525H33.506V88.487H31.2797V86.2525Z",
    fill: "url(#paint746_linear_816_5390)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 86.2525H35.7323V88.487H33.506V86.2525Z",
    fill: "url(#paint747_linear_816_5390)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 86.2525H37.9586V88.487H35.7323V86.2525Z",
    fill: "url(#paint748_linear_816_5390)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 86.2525H40.1849V88.487H37.9586V86.2525Z",
    fill: "url(#paint749_linear_816_5390)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 86.2525H42.4112V88.487H40.1849V86.2525Z",
    fill: "url(#paint750_linear_816_5390)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 86.2525H44.6375V88.487H42.4112V86.2525Z",
    fill: "url(#paint751_linear_816_5390)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 86.2525H46.8638V88.487H44.6375V86.2525Z",
    fill: "url(#paint752_linear_816_5390)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8638 86.2525H49.0901V88.487H46.8638V86.2525Z",
    fill: "url(#paint753_linear_816_5390)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 86.2525H62.448V88.487H60.2217V86.2525Z",
    fill: "url(#paint754_linear_816_5390)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 86.2525H64.6743V88.487H62.448V86.2525Z",
    fill: "url(#paint755_linear_816_5390)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 86.2525H69.1269V88.487H66.9006V86.2525Z",
    fill: "url(#paint756_linear_816_5390)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 86.2525H71.3532V88.487H69.1269V86.2525Z",
    fill: "url(#paint757_linear_816_5390)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 86.2525H73.5795V88.487H71.3532V86.2525Z",
    fill: "url(#paint758_linear_816_5390)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 86.2525H75.8058V88.487H73.5795V86.2525Z",
    fill: "url(#paint759_linear_816_5390)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 86.2525H78.0321V88.487H75.8058V86.2525Z",
    fill: "url(#paint760_linear_816_5390)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 86.2525H80.2584V88.487H78.0321V86.2525Z",
    fill: "url(#paint761_linear_816_5390)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 86.2525H82.4847V88.487H80.2584V86.2525Z",
    fill: "url(#paint762_linear_816_5390)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 86.2525H91.39V88.487H89.1636V86.2525Z",
    fill: "url(#paint763_linear_816_5390)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 86.2525H93.6163V88.487H91.39V86.2525Z",
    fill: "url(#paint764_linear_816_5390)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 86.2525H98.0689V88.487H95.8426V86.2525Z",
    fill: "url(#paint765_linear_816_5390)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 86.2525H100.295V88.487H98.0689V86.2525Z",
    fill: "url(#paint766_linear_816_5390)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 88.487H11.2429V90.7215H9.0166V88.487Z",
    fill: "url(#paint767_linear_816_5390)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 88.487H15.6955V90.7215H13.4692V88.487Z",
    fill: "url(#paint768_linear_816_5390)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 88.487H17.9218V90.7215H15.6955V88.487Z",
    fill: "url(#paint769_linear_816_5390)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 88.487H20.1481V90.7215H17.9218V88.487Z",
    fill: "url(#paint770_linear_816_5390)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 88.487H24.6007V90.7215H22.3744V88.487Z",
    fill: "url(#paint771_linear_816_5390)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 88.487H29.0534V90.7215H26.8271V88.487Z",
    fill: "url(#paint772_linear_816_5390)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 88.487H33.506V90.7215H31.2797V88.487Z",
    fill: "url(#paint773_linear_816_5390)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 88.487H35.7323V90.7215H33.506V88.487Z",
    fill: "url(#paint774_linear_816_5390)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 88.487H37.9586V90.7215H35.7323V88.487Z",
    fill: "url(#paint775_linear_816_5390)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 88.487H46.8638V90.7215H44.6375V88.487Z",
    fill: "url(#paint776_linear_816_5390)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 88.487H55.769V90.7215H53.5427V88.487Z",
    fill: "url(#paint777_linear_816_5390)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M55.769 88.487H57.9954V90.7215H55.769V88.487Z",
    fill: "url(#paint778_linear_816_5390)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 88.487H60.2217V90.7215H57.9954V88.487Z",
    fill: "url(#paint779_linear_816_5390)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 88.487H64.6743V90.7215H62.448V88.487Z",
    fill: "url(#paint780_linear_816_5390)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 88.487H66.9006V90.7215H64.6743V88.487Z",
    fill: "url(#paint781_linear_816_5390)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 88.487H69.1269V90.7215H66.9006V88.487Z",
    fill: "url(#paint782_linear_816_5390)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 88.487H73.5795V90.7215H71.3532V88.487Z",
    fill: "url(#paint783_linear_816_5390)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 88.487H82.4847V90.7215H80.2584V88.487Z",
    fill: "url(#paint784_linear_816_5390)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 88.487H84.711V90.7215H82.4847V88.487Z",
    fill: "url(#paint785_linear_816_5390)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 88.487H86.9373V90.7215H84.711V88.487Z",
    fill: "url(#paint786_linear_816_5390)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 88.487H89.1636V90.7215H86.9373V88.487Z",
    fill: "url(#paint787_linear_816_5390)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 88.487H91.39V90.7215H89.1636V88.487Z",
    fill: "url(#paint788_linear_816_5390)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 88.487H95.8426V90.7215H93.6163V88.487Z",
    fill: "url(#paint789_linear_816_5390)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 88.487H98.0689V90.7215H95.8426V88.487Z",
    fill: "url(#paint790_linear_816_5390)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 88.487H100.295V90.7215H98.0689V88.487Z",
    fill: "url(#paint791_linear_816_5390)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 90.7215H11.2429V92.956H9.0166V90.7215Z",
    fill: "url(#paint792_linear_816_5390)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 90.7215H15.6955V92.956H13.4692V90.7215Z",
    fill: "url(#paint793_linear_816_5390)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 90.7215H17.9218V92.956H15.6955V90.7215Z",
    fill: "url(#paint794_linear_816_5390)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 90.7215H20.1481V92.956H17.9218V90.7215Z",
    fill: "url(#paint795_linear_816_5390)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 90.7215H24.6007V92.956H22.3744V90.7215Z",
    fill: "url(#paint796_linear_816_5390)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 90.7215H29.0534V92.956H26.8271V90.7215Z",
    fill: "url(#paint797_linear_816_5390)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 90.7215H33.506V92.956H31.2797V90.7215Z",
    fill: "url(#paint798_linear_816_5390)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 90.7215H35.7323V92.956H33.506V90.7215Z",
    fill: "url(#paint799_linear_816_5390)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 90.7215H40.1849V92.956H37.9586V90.7215Z",
    fill: "url(#paint800_linear_816_5390)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 90.7215H42.4112V92.956H40.1849V90.7215Z",
    fill: "url(#paint801_linear_816_5390)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 90.7215H44.6375V92.956H42.4112V90.7215Z",
    fill: "url(#paint802_linear_816_5390)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 90.7215H46.8638V92.956H44.6375V90.7215Z",
    fill: "url(#paint803_linear_816_5390)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 90.7215H55.769V92.956H53.5427V90.7215Z",
    fill: "url(#paint804_linear_816_5390)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 90.7215H62.448V92.956H60.2217V90.7215Z",
    fill: "url(#paint805_linear_816_5390)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 90.7215H64.6743V92.956H62.448V90.7215Z",
    fill: "url(#paint806_linear_816_5390)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6743 90.7215H66.9006V92.956H64.6743V90.7215Z",
    fill: "url(#paint807_linear_816_5390)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 90.7215H73.5795V92.956H71.3532V90.7215Z",
    fill: "url(#paint808_linear_816_5390)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8058 90.7215H78.0321V92.956H75.8058V90.7215Z",
    fill: "url(#paint809_linear_816_5390)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 90.7215H82.4847V92.956H80.2584V90.7215Z",
    fill: "url(#paint810_linear_816_5390)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 90.7215H84.711V92.956H82.4847V90.7215Z",
    fill: "url(#paint811_linear_816_5390)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 90.7215H89.1636V92.956H86.9373V90.7215Z",
    fill: "url(#paint812_linear_816_5390)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 90.7215H93.6163V92.956H91.39V90.7215Z",
    fill: "url(#paint813_linear_816_5390)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 90.7215H95.8426V92.956H93.6163V90.7215Z",
    fill: "url(#paint814_linear_816_5390)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 90.7215H98.0689V92.956H95.8426V90.7215Z",
    fill: "url(#paint815_linear_816_5390)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0689 90.7215H100.295V92.956H98.0689V90.7215Z",
    fill: "url(#paint816_linear_816_5390)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 92.956H11.2429V95.1906H9.0166V92.956Z",
    fill: "url(#paint817_linear_816_5390)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 92.956H15.6955V95.1906H13.4692V92.956Z",
    fill: "url(#paint818_linear_816_5390)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 92.956H17.9218V95.1906H15.6955V92.956Z",
    fill: "url(#paint819_linear_816_5390)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 92.956H20.1481V95.1906H17.9218V92.956Z",
    fill: "url(#paint820_linear_816_5390)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 92.956H24.6007V95.1906H22.3744V92.956Z",
    fill: "url(#paint821_linear_816_5390)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 92.956H29.0534V95.1906H26.8271V92.956Z",
    fill: "url(#paint822_linear_816_5390)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 92.956H33.506V95.1906H31.2797V92.956Z",
    fill: "url(#paint823_linear_816_5390)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 92.956H37.9586V95.1906H35.7323V92.956Z",
    fill: "url(#paint824_linear_816_5390)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 92.956H40.1849V95.1906H37.9586V92.956Z",
    fill: "url(#paint825_linear_816_5390)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 92.956H53.5427V95.1906H51.3164V92.956Z",
    fill: "url(#paint826_linear_816_5390)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5427 92.956H55.769V95.1906H53.5427V92.956Z",
    fill: "url(#paint827_linear_816_5390)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M62.448 92.956H64.6743V95.1906H62.448V92.956Z",
    fill: "url(#paint828_linear_816_5390)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 92.956H69.1269V95.1906H66.9006V92.956Z",
    fill: "url(#paint829_linear_816_5390)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 92.956H71.3532V95.1906H69.1269V92.956Z",
    fill: "url(#paint830_linear_816_5390)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 92.956H73.5795V95.1906H71.3532V92.956Z",
    fill: "url(#paint831_linear_816_5390)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 92.956H80.2584V95.1906H78.0321V92.956Z",
    fill: "url(#paint832_linear_816_5390)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 92.956H82.4847V95.1906H80.2584V92.956Z",
    fill: "url(#paint833_linear_816_5390)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4847 92.956H84.711V95.1906H82.4847V92.956Z",
    fill: "url(#paint834_linear_816_5390)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 92.956H86.9373V95.1906H84.711V92.956Z",
    fill: "url(#paint835_linear_816_5390)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 92.956H89.1636V95.1906H86.9373V92.956Z",
    fill: "url(#paint836_linear_816_5390)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 92.956H91.39V95.1906H89.1636V92.956Z",
    fill: "url(#paint837_linear_816_5390)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 92.956H95.8426V95.1906H93.6163V92.956Z",
    fill: "url(#paint838_linear_816_5390)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 92.956H98.0689V95.1906H95.8426V92.956Z",
    fill: "url(#paint839_linear_816_5390)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 95.1906H11.2429V97.4251H9.0166V95.1906Z",
    fill: "url(#paint840_linear_816_5390)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 95.1906H24.6007V97.4251H22.3744V95.1906Z",
    fill: "url(#paint841_linear_816_5390)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 95.1906H33.506V97.4251H31.2797V95.1906Z",
    fill: "url(#paint842_linear_816_5390)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M33.506 95.1906H35.7323V97.4251H33.506V95.1906Z",
    fill: "url(#paint843_linear_816_5390)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 95.1906H37.9586V97.4251H35.7323V95.1906Z",
    fill: "url(#paint844_linear_816_5390)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 95.1906H40.1849V97.4251H37.9586V95.1906Z",
    fill: "url(#paint845_linear_816_5390)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 95.1906H44.6375V97.4251H42.4112V95.1906Z",
    fill: "url(#paint846_linear_816_5390)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 95.1906H46.8638V97.4251H44.6375V95.1906Z",
    fill: "url(#paint847_linear_816_5390)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0901 95.1906H51.3164V97.4251H49.0901V95.1906Z",
    fill: "url(#paint848_linear_816_5390)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3164 95.1906H53.5427V97.4251H51.3164V95.1906Z",
    fill: "url(#paint849_linear_816_5390)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9954 95.1906H60.2217V97.4251H57.9954V95.1906Z",
    fill: "url(#paint850_linear_816_5390)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2217 95.1906H62.448V97.4251H60.2217V95.1906Z",
    fill: "url(#paint851_linear_816_5390)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9006 95.1906H69.1269V97.4251H66.9006V95.1906Z",
    fill: "url(#paint852_linear_816_5390)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 95.1906H71.3532V97.4251H69.1269V95.1906Z",
    fill: "url(#paint853_linear_816_5390)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3532 95.1906H73.5795V97.4251H71.3532V95.1906Z",
    fill: "url(#paint854_linear_816_5390)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2584 95.1906H82.4847V97.4251H80.2584V95.1906Z",
    fill: "url(#paint855_linear_816_5390)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 95.1906H86.9373V97.4251H84.711V95.1906Z",
    fill: "url(#paint856_linear_816_5390)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 95.1906H91.39V97.4251H89.1636V95.1906Z",
    fill: "url(#paint857_linear_816_5390)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M91.39 95.1906H93.6163V97.4251H91.39V95.1906Z",
    fill: "url(#paint858_linear_816_5390)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6163 95.1906H95.8426V97.4251H93.6163V95.1906Z",
    fill: "url(#paint859_linear_816_5390)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8426 95.1906H98.0689V97.4251H95.8426V95.1906Z",
    fill: "url(#paint860_linear_816_5390)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 97.4251H11.2429V99.6596H9.0166V97.4251Z",
    fill: "url(#paint861_linear_816_5390)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2429 97.4251H13.4692V99.6596H11.2429V97.4251Z",
    fill: "url(#paint862_linear_816_5390)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 97.4251H15.6955V99.6596H13.4692V97.4251Z",
    fill: "url(#paint863_linear_816_5390)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6955 97.4251H17.9218V99.6596H15.6955V97.4251Z",
    fill: "url(#paint864_linear_816_5390)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 97.4251H20.1481V99.6596H17.9218V97.4251Z",
    fill: "url(#paint865_linear_816_5390)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 97.4251H22.3744V99.6596H20.1481V97.4251Z",
    fill: "url(#paint866_linear_816_5390)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 97.4251H24.6007V99.6596H22.3744V97.4251Z",
    fill: "url(#paint867_linear_816_5390)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0534 97.4251H31.2797V99.6596H29.0534V97.4251Z",
    fill: "url(#paint868_linear_816_5390)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 97.4251H33.506V99.6596H31.2797V97.4251Z",
    fill: "url(#paint869_linear_816_5390)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7323 97.4251H37.9586V99.6596H35.7323V97.4251Z",
    fill: "url(#paint870_linear_816_5390)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9586 97.4251H40.1849V99.6596H37.9586V97.4251Z",
    fill: "url(#paint871_linear_816_5390)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 97.4251H42.4112V99.6596H40.1849V97.4251Z",
    fill: "url(#paint872_linear_816_5390)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4112 97.4251H44.6375V99.6596H42.4112V97.4251Z",
    fill: "url(#paint873_linear_816_5390)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6375 97.4251H46.8638V99.6596H44.6375V97.4251Z",
    fill: "url(#paint874_linear_816_5390)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1269 97.4251H71.3532V99.6596H69.1269V97.4251Z",
    fill: "url(#paint875_linear_816_5390)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5795 97.4251H75.8058V99.6596H73.5795V97.4251Z",
    fill: "url(#paint876_linear_816_5390)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0321 97.4251H80.2584V99.6596H78.0321V97.4251Z",
    fill: "url(#paint877_linear_816_5390)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M84.711 97.4251H86.9373V99.6596H84.711V97.4251Z",
    fill: "url(#paint878_linear_816_5390)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9373 97.4251H89.1636V99.6596H86.9373V97.4251Z",
    fill: "url(#paint879_linear_816_5390)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1636 97.4251H91.39V99.6596H89.1636V97.4251Z",
    fill: "url(#paint880_linear_816_5390)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0718,
    y: 38.2104,
    width: 30.0551,
    height: 30.1661,
    rx: 3.2,
    fill: "white"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0947 42H54.3295V54.0144H61.9964V56.6478H51.0947V42Z",
    fill: "#C60C30"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0125 57.1478H62.0318L61.4079 56.3418L55.0152 48.0831L61.0314 42.3623L61.9383 41.5H60.6869H56.5069H56.2984L56.1517 41.6481L51.0309 46.8169V42V41.5H50.5309H47.3486H46.8486V42V56.6478V57.1478H47.3486H50.5309H51.0309V56.6478V51.9599L52.0149 51.0036L56.4528 56.947L56.6028 57.1478H56.8535H61.0125Z",
    fill: "#003478",
    stroke: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5933 61.3852C60.5933 61.5133 60.6093 61.6397 60.6413 61.7642C60.6769 61.8852 60.7285 61.9938 60.7961 62.0899C60.8673 62.186 60.9563 62.2625 61.0631 62.3194C61.1734 62.3764 61.3015 62.4049 61.4474 62.4049C61.6005 62.4049 61.7304 62.3746 61.8372 62.3141C61.9439 62.2536 62.0311 62.1753 62.0987 62.0792C62.1664 61.9795 62.2144 61.8674 62.2429 61.7429C62.2749 61.6183 62.2909 61.492 62.2909 61.3638C62.2909 61.2286 62.2749 61.0987 62.2429 60.9741C62.2109 60.846 62.1592 60.7339 62.0881 60.6378C62.0204 60.5417 61.9315 60.4652 61.8211 60.4082C61.7108 60.3477 61.5773 60.3175 61.4207 60.3175C61.2677 60.3175 61.1378 60.3477 61.031 60.4082C60.9243 60.4687 60.8388 60.5488 60.7748 60.6485C60.7107 60.7481 60.6644 60.862 60.636 60.9901C60.6075 61.1183 60.5933 61.2499 60.5933 61.3852ZM62.7287 62.7412H62.2749V62.3675H62.2642C62.1895 62.5205 62.072 62.6309 61.9119 62.6985C61.7517 62.7661 61.5756 62.7999 61.3834 62.7999C61.1698 62.7999 60.983 62.7608 60.8228 62.6825C60.6662 62.6042 60.5345 62.4992 60.4278 62.3675C60.3246 62.2358 60.2463 62.0828 60.1929 61.9084C60.1395 61.734 60.1128 61.5489 60.1128 61.3532C60.1128 61.1574 60.1377 60.9723 60.1875 60.7979C60.2409 60.6235 60.3192 60.4723 60.4224 60.3442C60.5292 60.2125 60.6609 60.1093 60.8175 60.0345C60.9776 59.9562 61.1627 59.9171 61.3727 59.9171C61.4439 59.9171 61.5204 59.9242 61.6023 59.9384C61.6841 59.9527 61.766 59.9776 61.8478 60.0132C61.9297 60.0452 62.0062 60.0897 62.0774 60.1466C62.1521 60.2 62.2144 60.2676 62.2642 60.3495H62.2749V58.9294H62.7287V62.7412Z",
    fill: "#003478"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8397 62.7304C59.7614 62.7767 59.6528 62.7998 59.514 62.7998C59.3966 62.7998 59.3022 62.7678 59.2311 62.7037C59.1634 62.6361 59.1296 62.5276 59.1296 62.3781C59.0051 62.5276 58.8591 62.6361 58.6919 62.7037C58.5282 62.7678 58.3502 62.7998 58.158 62.7998C58.0334 62.7998 57.9142 62.7856 57.8003 62.7571C57.69 62.7286 57.5939 62.6842 57.512 62.6236C57.4302 62.5631 57.3643 62.4848 57.3145 62.3887C57.2683 62.2891 57.2451 62.1699 57.2451 62.0311C57.2451 61.8745 57.2718 61.7463 57.3252 61.6467C57.3786 61.547 57.448 61.467 57.5334 61.4065C57.6224 61.3424 57.722 61.2943 57.8324 61.2623C57.9462 61.2303 58.0619 61.2036 58.1794 61.1822C58.3039 61.1573 58.4214 61.1395 58.5317 61.1288C58.6456 61.1146 58.7453 61.0968 58.8307 61.0755C58.9161 61.0505 58.9837 61.0167 59.0335 60.974C59.0834 60.9278 59.1083 60.8619 59.1083 60.7765C59.1083 60.6768 59.0887 60.5968 59.0496 60.5363C59.014 60.4758 58.9659 60.4295 58.9054 60.3975C58.8485 60.3654 58.7826 60.3441 58.7079 60.3334C58.6367 60.3227 58.5655 60.3174 58.4943 60.3174C58.3022 60.3174 58.142 60.3548 58.0139 60.4295C57.8857 60.5007 57.8163 60.6377 57.8057 60.8406H57.3519C57.359 60.6697 57.3946 60.5256 57.4587 60.4081C57.5227 60.2907 57.6081 60.1964 57.7149 60.1252C57.8217 60.0505 57.9427 59.9971 58.0779 59.965C58.2167 59.933 58.3644 59.917 58.521 59.917C58.6456 59.917 58.7684 59.9259 58.8894 59.9437C59.014 59.9615 59.1261 59.9989 59.2257 60.0558C59.3254 60.1092 59.4055 60.1857 59.466 60.2854C59.5265 60.385 59.5567 60.5149 59.5567 60.6751V62.0951C59.5567 62.2019 59.5621 62.2802 59.5727 62.33C59.587 62.3799 59.6297 62.4048 59.7009 62.4048C59.74 62.4048 59.7863 62.3959 59.8397 62.3781V62.7304ZM59.1029 61.3157C59.046 61.3584 58.9713 61.3904 58.8787 61.4118C58.7862 61.4296 58.6883 61.4456 58.5851 61.4598C58.4854 61.4705 58.384 61.4848 58.2808 61.5025C58.1776 61.5168 58.0851 61.5417 58.0032 61.5773C57.9213 61.6129 57.8537 61.6645 57.8003 61.7321C57.7505 61.7962 57.7256 61.8851 57.7256 61.999C57.7256 62.0738 57.7398 62.1378 57.7683 62.1912C57.8003 62.241 57.8395 62.282 57.8857 62.314C57.9356 62.346 57.9925 62.3692 58.0566 62.3834C58.1206 62.3976 58.1883 62.4048 58.2594 62.4048C58.4089 62.4048 58.5371 62.3852 58.6438 62.346C58.7506 62.3033 58.8378 62.2517 58.9054 62.1912C58.973 62.1272 59.0229 62.0595 59.0549 61.9884C59.0869 61.9136 59.1029 61.8442 59.1029 61.7802V61.3157Z",
    fill: "#003478"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M56.444 61.0968C56.4368 60.99 56.4119 60.8886 56.3692 60.7925C56.3301 60.6964 56.2749 60.6146 56.2037 60.5469C56.1361 60.4758 56.0542 60.4206 55.9581 60.3814C55.8656 60.3387 55.7624 60.3174 55.6485 60.3174C55.5311 60.3174 55.4243 60.3387 55.3282 60.3814C55.2357 60.4206 55.1556 60.4758 55.088 60.5469C55.0203 60.6181 54.967 60.7018 54.9278 60.7979C54.8887 60.8904 54.8655 60.99 54.8584 61.0968H56.444ZM56.8817 61.8656C56.8212 62.1752 56.6877 62.4083 56.4813 62.5649C56.2749 62.7215 56.0151 62.7998 55.7019 62.7998C55.4812 62.7998 55.289 62.7642 55.1253 62.693C54.9652 62.6219 54.8299 62.5222 54.7196 62.3941C54.6093 62.266 54.5256 62.1129 54.4687 61.935C54.4153 61.757 54.385 61.5631 54.3779 61.3531C54.3779 61.1431 54.41 60.9509 54.474 60.7765C54.5381 60.6021 54.6271 60.4508 54.741 60.3227C54.8584 60.1946 54.9954 60.0949 55.152 60.0238C55.3122 59.9526 55.4866 59.917 55.6752 59.917C55.9208 59.917 56.1236 59.9686 56.2838 60.0718C56.4475 60.1715 56.5774 60.2996 56.6735 60.4562C56.7732 60.6128 56.8408 60.7836 56.8764 60.9687C56.9155 61.1538 56.9315 61.3299 56.9244 61.4972H54.8584C54.8548 61.6182 54.8691 61.7339 54.9011 61.8442C54.9331 61.951 54.9847 62.0471 55.0559 62.1325C55.1271 62.2144 55.2179 62.2802 55.3282 62.33C55.4385 62.3799 55.5684 62.4048 55.7179 62.4048C55.9101 62.4048 56.0667 62.3603 56.1877 62.2713C56.3123 62.1823 56.3941 62.0471 56.4333 61.8656H56.8817Z",
    fill: "#003478"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6357 58.9294H52.1429V62.3141H54.1609V62.7412H51.6357V58.9294Z",
    fill: "#003478"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4116 61.0435H50.9545V61.4705H49.4116V61.0435Z",
    fill: "#003478"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M46 58.9294H46.5072V60.83L48.4397 58.9294H49.0964L47.4895 60.467L49.1604 62.7412H48.5198L47.1425 60.814L46.5072 61.4065V62.7412H46V58.9294Z",
    fill: "#003478"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint516_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint517_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint518_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint519_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint520_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint521_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint522_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint523_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint524_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint525_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint526_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint527_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint528_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint529_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint530_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint531_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint532_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint533_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint534_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint535_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint536_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint537_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint538_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint539_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint540_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint541_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint542_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint543_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint544_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint545_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint546_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint547_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint548_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint549_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint550_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint551_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint552_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint553_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint554_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint555_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint556_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint557_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint558_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint559_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint560_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint561_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint562_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint563_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint564_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint565_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint566_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint567_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint568_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint569_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint570_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint571_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint572_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint573_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint574_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint575_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint576_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint577_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint578_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint579_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint580_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint581_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint582_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint583_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint584_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint585_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint586_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint587_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint588_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint589_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint590_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint591_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint592_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint593_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint594_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint595_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint596_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint597_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint598_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint599_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint600_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint601_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint602_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint603_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint604_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint605_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint606_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint607_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint608_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint609_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint610_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint611_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint612_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint613_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint614_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint615_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint616_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint617_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint618_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint619_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint620_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint621_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint622_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint623_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint624_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint625_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint626_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint627_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint628_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint629_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint630_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint631_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint632_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint633_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint634_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint635_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint636_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint637_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint638_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint639_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint640_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint641_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint642_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint643_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint644_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint645_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint646_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint647_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint648_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint649_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint650_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint651_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint652_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint653_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint654_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint655_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint656_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint657_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint658_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint659_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint660_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint661_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint662_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint663_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint664_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint665_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint666_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint667_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint668_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint669_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint670_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint671_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint672_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint673_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint674_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint675_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint676_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint677_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint678_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint679_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint680_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint681_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint682_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint683_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint684_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint685_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint686_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint687_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint688_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint689_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint690_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint691_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint692_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint693_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint694_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint695_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint696_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint697_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint698_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint699_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint700_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint701_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint702_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint703_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint704_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint705_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint706_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint707_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint708_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint709_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint710_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint711_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint712_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint713_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint714_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint715_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint716_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint717_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint718_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint719_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint720_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint721_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint722_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint723_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint724_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint725_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint726_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint727_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint728_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint729_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint730_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint731_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint732_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint733_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint734_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint735_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint736_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint737_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint738_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint739_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint740_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint741_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint742_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint743_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint744_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint745_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint746_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint747_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint748_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint749_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint750_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint751_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint752_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint753_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint754_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint755_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint756_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint757_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint758_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint759_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint760_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint761_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint762_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint763_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint764_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint765_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint766_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint767_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint768_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint769_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint770_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint771_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint772_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint773_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint774_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint775_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint776_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint777_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint778_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint779_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint780_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint781_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint782_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint783_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint784_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint785_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint786_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint787_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint788_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint789_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint790_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint791_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint792_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint793_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint794_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint795_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint796_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint797_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint798_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint799_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint800_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint801_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint802_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint803_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint804_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint805_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint806_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint807_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint808_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint809_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint810_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint811_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint812_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint813_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint814_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint815_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint816_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint817_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint818_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint819_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint820_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint821_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint822_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint823_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint824_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint825_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint826_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint827_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint828_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint829_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint830_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint831_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint832_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint833_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint834_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint835_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint836_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint837_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint838_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint839_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint840_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint841_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint842_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint843_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint844_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint845_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint846_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint847_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint848_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint849_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint850_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint851_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint852_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint853_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint854_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint855_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint856_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint857_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint858_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint859_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint860_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint861_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint862_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint863_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint864_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint865_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint866_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint867_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint868_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint869_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint870_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint871_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint872_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint873_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint874_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint875_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint876_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint877_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint878_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint879_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint880_linear_816_5390",
    x1: 8.97209,
    y1: 7.9995,
    x2: 100.676,
    y2: 99.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC900"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupQrCodeIconKlead);
export default __webpack_public_path__ + "static/media/popupQRCodeIconKlead.a67eefd8d1e7f1d905429c7135f16acf.svg";
export { ForwardRef as ReactComponent };